import { Accordion, AccordionSummary, AccordionDetails, Box, Dialog, Collapse, Menu, MenuItem, AppBar, ListItemText, Toolbar, ListItemIcon, TableContainer, Checkbox, Modal, DialogActions, DialogContent, Table, TableHead, TableBody, TableRow, TableCell, useTheme, Tooltip, FormControl, Card, Autocomplete, Grid, Typography, Stack, Divider, TextField, CardContent, Chip, IconButton, Button, alpha, useMediaQuery, Pagination } from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";

import Close from '@mui/icons-material/Close';

import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import Header from "../../../Layout/Header";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';


import CallAlertBar from "../../../Layout/Alertbar";
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded';

import qrcode from 'qrcode';
import { useTranslation } from "react-i18next";
import QualityCheckRejectProcee from "../qc/QCRejectReelProcess";

import LabelBundleDetails from "../labels/Bundle";
import CloseIcon from '@mui/icons-material/Close';
import GlobalConfig from "../../../config/date/GlobalConfig";
import Searchicon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import ListAltIcon from '@mui/icons-material/ListAlt';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import RefreshIcon from '@mui/icons-material/Refresh';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import ArticleIcon from '@mui/icons-material/Article';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import InfoIcon from '@mui/icons-material/Info';
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import { ExpandMore, ExpandLess, Grade, DoubleArrowRounded, Edit } from '@mui/icons-material';
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import { tokens } from "../../../theme/theme";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import TableFilterRow from "../../../components/table/TableFilterRow";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import useRemarks from "../../../hooks/common/useRemarks";
import AddRemarks from "../../master/AddRemarks";

const BundleLabel = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    const [orderFromDate, setOrderFromDate] = useState(dayjs());
    const [orderToDate, setOrderToDate] = useState(dayjs());

    const [sheeterChildRoll, setSheeterChildRoll] = useState([]);
    const [sheeterSelectedChildRoll, setSheeterSelectedChildRoll] = useState(null);
    const [selectedSheeterChildRollDetail, setSelectedSheeterChildRollDetail] = useState([]);

    // message 
    const [sheeterMsgOpen, setSheeterMsgOpen] = useState(false);
    const [sheeterSeverityvalue, setSheeterSeverityvalue] = useState('info');
    const [sheeterMessageValue, setSheeterMessageValue] = useState('');
    const [sheeterAlertTitleValue, setSheeterAlertTitleValue] = useState('');
    const [rows, setRows] = useState(/* initial rows */);

    // pallet details
    const [palletID, setPalletID] = useState(0);
    const [palletCode, setPalletCode] = useState('');
    const [palletStatus, setPalletStatus] = useState('');
    const [lotNumber, setLotNumber] = useState(0);
    const [price, setPrice] = useState(0);
    const [quality, setQuality] = useState('');
    const [gsm, setGSM] = useState('');
    const [finisherNumber, setFinisherNumber] = useState('');
    const [numberofReams, setNumberOfReams] = useState(0);
    const [lossReams, setlossReams] = useState(0);
    const [size, setSize] = useState('');
    const [jumboNumber, setJumboNumber] = useState('');
    const [numberofSheets, setNumberOfSheets] = useState(0);
    const [label, setLabel] = useState('');
    const [reamWeignt, setReamWeight] = useState(0);
    const [lReamWeignt, setLReamWeight] = useState(0);
    const [allocatedSheets, setAllocatedSheets] = useState(0);
    const [palletWeight, setPalletWeight] = useState(0);
    const [palletWeightInKgs, setPalletWeightInKgs] = useState('');
    const [releaseNumber, setReleaseNumber] = useState('');


    const [approvedPalletNumber, setApprovedPalletNumber] = useState([]);
    const [totalReams, setTotalReams] = useState(0);
    const [balanceSheet, setBalanceSheet] = useState(0);
    const [disableSaveBtn, setDisableSaveBtn] = useState(false);
    const [disbleSheetValue, setDisbleSheetValue] = useState(false);
    const [selectedReamDetails, setSelectedReamDetails] = useState(null);
    const [viewSheeterchildRollDetail, setviewSheeterchildRollDetail] = useState(false);
    // table data view 
    const sizecolumns = ['SNo', 'ReamNumber', 'Ream Weight', 'Sheets', 'Status'];
    const [selectedReam, setSelectedReam] = useState(null);
    const [selectedReamDetailsQR, setSelectedReamDetailsQR] = useState(null);
    const [viewQRCodeDetails, setViewQRCodeDetails] = useState(false);
    const [viewReamLabeling, setViewReamLabeling] = useState(false);
    const [selectedButton, setSelectedButton] = useState(null);
    const [viewReamsList, setViewReamsList] = useState(false);

    const [reamList, setReamList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [bundleListLoding, setBundleListLoading] = useState(false);

    // reject reason
    const [rejectReason, setRejectReason] = useState([]);
    const [selectedReason, setSelectedReason] = useState([]);
    const [rejectProductType, setRejectProductType] = useState(null);
    const [rejectStatus, setRejectStatus] = useState(false);
    const [rejectReasonID, setRejectReasonID] = useState(0);
    const [rejectRemarks, setRejectRemarks] = useState(null);
    const [enableReject, setEnableReject] = useState(false);
    const [enableReverseProcess, setEnableReverseProcess] = useState(true);
    const [period, setPeriod] = useState('Today');
    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [selectedRows, setSelectedRows] = useState([]);


    const [errorMessage, setErrorMessage] = useState('');
    const [shiftdate_errorMessage, setshiftdate_errorMessage] = useState('');

    const [shiftCodes, setShiftCodes] = useState([]);
    const [winderOperators, setWinderOperators] = useState('');
    const [winderShiftCode, setWinderShiftCode] = useState('');
    const [winderShiftID, setWinderShiftID] = useState(0);
    const [winderShiftDate, setWinderShiftDate] = useState(dayjs());
    const [shiftDate, setShiftDate] = useState(dayjs());
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    // OPERATORS
    const [operator, setOperator] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState([]);
    const [selectedOperatorName, setSelectedOperatorName] = useState([]);
    const [operatorID, setOperatorID] = useState([]);
    const [isOperatorDataLoaded, setIsOperatorDataLoaded] = useState(false);

    const [selectedSetNumberStatus, SetSelectedSetNumberStatus] = useState(null);
    const [setNumberList, setSetNumberList] = useState([]);
    const [disableNumberofSheets, setDisableNumberofSheets] = useState(false);

    const [sheeterNoOfSheets, setSheeterNoOfSheets] = useState(0);
    const [viewReamQRCode, setViewReamQRCode] = useState(false);
    const [selectedReamRows, setSelectedReamRows] = useState([]);

    const [summaryList, setSummaryList] = useState([]);
    const [maxWightBundle, setMaxWeightBundle] = useState(55);
    const [bundleDetails, setBundleDetails] = useState([]);
    const [bundleList, setBundleList] = useState([]);
    const [bundleWiseReam, setBundleWiseReam] = useState([]);
    const [refreshCalculation, setRefreshCalculation] = useState(false);
    const [packingWeight, setPackingWeight] = useState(0);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('Bundle Punching Summary');
    const openFirst = Boolean(anchorElFirst);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);


    const [isGrossWeight, setIsGrossWeight] = useState(false);
    const [loading, setLoading] = useState(false);

    const [locationDetail, setLocationDetail] = useState([]);
    const [selectedGrade, setSelectedGrade] = useState([]);
    const [locationRef, setLocationRef] = useState('');
    const [loadingOrderItemDet, setLoadingOrderItemDet] = useState(false);

    const [filterIndentno, setFilterIndentno] = useState('');
    const [indentNoList, setIndentNoList] = useState([]);

    const [expandedRow, setExpandedRow] = useState(null);  // Track which row is expanded
    const [expandedData, setExpandedData] = useState({});
    const [disableDeleteBtn, setDisableDeleteBtn] = useState(true);
    const [FromShiftDate, setFromShiftDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToShiftDate, setToShiftDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const userPermissions = useUserPermissions();
    // Function to update a specific field for a specific ream
    const [openWIPListModal, setOpenWIPListModal] = useState(false);

    //Remarks Dropdown
    // Inside the PaperRollProduction component
    const [remarks, setRemarks] = useState(null);
    // const [remarkOptions, setRemarkOptions] = useState([]);
    // const [loadingRemarks, setLoadingRemarks] = useState(false);
    const [openAddRemark, setOpenAddRemark] = useState(false);
    const [supervisorRemarks, setSupervisorRemarks] = useState('');
    const [grade, setGrade] = useState('');
    // const [parentModuleId, setParentModuleId] = useState(0);
    // const [moduleId, setModuleId] = useState(0);

    const moduledetails = userPermissions.find(
        (m) =>
            m.module_name === "Bundle Punching" &&
            m.parent_module_name === "Production"
    );

    const { remarkOptions, loadingRemarks, refetchRemarks } = useRemarks(moduledetails);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page

    // Responsive breakpoints
    const isXs = useMediaQuery((theme) => theme.breakpoints.only("xs"));
    const isSm = useMediaQuery((theme) => theme.breakpoints.only("sm"));
    const isMd = useMediaQuery((theme) => theme.breakpoints.only("md"));
    const isLg = useMediaQuery((theme) => theme.breakpoints.only("lg"));
    const isXl = useMediaQuery((theme) => theme.breakpoints.only("xl"));


    // Update recordsPerPage based on screen size
    useEffect(() => {
        if (isXs) setRecordsPerPage(20);
        else if (isSm) setRecordsPerPage(10);
        else if (isMd) setRecordsPerPage(10);
        else if (isLg) setRecordsPerPage(15);
        else if (isXl) setRecordsPerPage(27);
    }, [isXs, isSm, isMd, isLg, isXl]);
    //


    // Handlers for AddRemarks dialog
    const handleOpenAddRemark = () => setOpenAddRemark(true);

    const handleCloseAddRemark = () => {
        setOpenAddRemark(false);
        refetchRemarks();
    };

    // Correct Handlers for the modal
    const handleOpenWIPListModal = () => {
        setOpenWIPListModal(true);
    };

    const handleCloseWIPListModal = () => {
        setOpenWIPListModal(false);
    };

    const handleBackSheeterMachineEntry = () => {
        setOpenWIPListModal(false);
    };
    const handleExpandRow = async (row) => {
        const { indent_no } = row;
        // Toggle expansion
        if (expandedRow === indent_no) {
            setExpandedRow(null);
            return;
        }

        try {



            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_indent_no: row.indent_no,
                p_line_no: row.line_no,
                p_release_no: 0,

            };


            callApi(API_ENDPOINTS.PROD_MANAGEMENT__GET_ORDER_LINE_ITEMS_WISE_REAM_LIST, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setExpandedData((prev) => ({ ...prev, [indent_no]: data }));
                        setExpandedRow(indent_no);

                        console.log('test', expandedData)
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        } catch (error) {
            console.error("Failed to fetch expanded row data", error);
        }

    };




    const fetchIndentNo = async () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 0,
        }

        try {
            const data = await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_DISTINCT_ORDERITEM_BUNDLE_PUNCHING, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data?.length > 0) {
                setIndentNoList(data);
            }
        }
        catch (error) {
            alert(error);
        }
    }


    useEffect(() => {
        fetchIndentNo();
    }, [])


    //     if (!isGrossWeight) {
    //         const para = {
    //             p_companyid: localStorage.getItem('companyid'),
    //             p_id_default_value: 4
    //         }

    //         callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_DEFAULT_VALUES, 'POST', { 'Content-Type': 'application/json' }, para)
    //             .then(result => {
    //                 if (result && result.length > 0) {

    //                     if (result[0].double_value > 0) {
    //                         setMaxWeightBundle(result[0].double_value);
    //                         setIsGrossWeight(true);
    //                     }
    //                     else {
    //                         alert('Please set default maximum weight per bundle value');
    //                     }

    //                 }
    //             })
    //             .catch(error => {
    //                 alert(error.message);
    //             });


    //         const para1 = {
    //             p_companyid: localStorage.getItem('companyid'),
    //             p_id_default_value: 2
    //         }

    //         callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_DEFAULT_VALUES, 'POST', { 'Content-Type': 'application/json' }, para1)
    //             .then(result1 => {
    //                 if (result1 && result1.length > 0) {

    //                     if (result1[0].double_value > 0) {
    //                         setPackingWeight(result1[0].double_value);
    //                         setIsGrossWeight(true);
    //                     }
    //                     else {
    //                         alert('Please set default maximum weight per bundle value');
    //                     }

    //                 }
    //             })
    //             .catch(error => {
    //                 alert(error.message);
    //             });

    //     }
    // }, [isGrossWeight]);

    // Handlers for first menu

    useEffect(() => {
        if (isGrossWeight) return;

        const companyId = localStorage.getItem('companyid');

        const fetchDefaultValue = async (id, setter, alertMsg) => {
            try {
                const para = { p_companyid: companyId, p_id_default_value: id };
                const result = await callApi(
                    API_ENDPOINTS.PROD_MANAGEMENT_GET_DEFAULT_VALUES,
                    'POST',
                    { 'Content-Type': 'application/json' },
                    para
                );

                if (result?.length && result[0].double_value > 0) {
                    setter(result[0].double_value);
                    setIsGrossWeight(true);
                } else {
                    alert(alertMsg);
                }
            } catch (error) {
                alert(error.message);
            }
        };

        fetchDefaultValue(4, setMaxWeightBundle, 'Please set default maximum weight per bundle value');
        fetchDefaultValue(2, setPackingWeight, 'Please set default packing weight value');
    }, [isGrossWeight]);

    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Bundle Punching') {
            setSelectedStatus('All');
        }
        else if (option === 'Unweighted Reels') {
            setSelectedStatus('Booked');
        }
        else if (option === 'FG Child Roll') {
            setSelectedStatus('fg');
        }
        else if (option === 'Inprogress Child Roll') {
            setSelectedStatus('wip');
        }
        else if (option === 'Cancelled Child Roll') {
            setSelectedStatus('cancelled');
        }

        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const handleShowNewVendor = () => {
        setJobID(0);
        setViewJob(false);
        setViewReamQRCode(false);
        setNewJob(true);
        setviewReamProcess(false);
        setViewLineItemList(true);
        setviewPalletList(false);
        LoadOrderItemDetails(FromDate, ToDate);

    }


    const updateRows = (updatedRows) => {
        setRows(updatedRows);
        setApprovedPalletNumber(updatedRows)
    };


    const callback = () => {
        handleBackWinderMachineEntry();
    };

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        LoadOrderItemDetails(date, ToDate);
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        LoadOrderItemDetails(FromDate, date);
    };

    const [editMode, setEditMode] = useState(false);

    // filter data new concept
    const [filters, setFilters] = useState({
        job_number: '',
        indent_no: '',
        item_code: '',
        cr_number: ''

    });

    const [cr_number, setcr_number] = useState([]);



    const handleSelectSheeterChildRollNumber = (event, value) => {

        setSheeterSelectedChildRoll(value);
        setPalletID(value.pld_id)
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_pallet_number: value.plt_number,
            p_mode: 0,
            p_child_reel_number: ''
        };


        // get Pallet details

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PALLET_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {

                if (data && data.length > 0) {
                    setSelectedSheeterChildRollDetail(data);
                    // update detail
                    setPalletCode(data[0].pr_number);
                    setLotNumber(data[0].lot_no);
                    setQuality(data[0].item_code);
                    setGSM(data[0].gsm);
                    setSize(data[0].size);
                    setAllocatedSheets(data[0].no_of_sheets);
                    setPalletWeight(data[0].pallet_weight);
                    setPalletWeightInKgs(data[0].pallet_weight_unit);
                    setReleaseNumber(data[0].release_no);

                    setDisableSaveBtn(false);
                    setDisbleSheetValue(false);
                    setViewReamLabeling(true);
                    setShowCard(true);
                    setSelectedReam(null);

                    // ream details

                    setPalletStatus('WIP')
                    setLReamWeight(0)
                    setReamWeight(0);
                    setTotalReams(0);
                    setBalanceSheet(0);
                    setlossReams(0);
                    setNumberOfReams(0);
                    setNumberOfSheets(0);
                    setViewReamsList(false);
                    setApprovedPalletNumber(null);
                    setSelectedReamDetailsQR(null);


                    const reamData = {
                        p_companyid: localStorage.getItem('companyid'),
                        p_pallet_id: value.pld_id,
                    };

                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_DETAILS_APPROVED_PALLET, 'POST', { 'Content-Type': 'application/json' }, reamData)
                        .then(data1 => {
                            if (data1 && data1.length > 0) {
                                // Update state with fetched data
                                setNumberOfSheets(data1[0].no_of_sheets);
                                setReamWeight(data1[0].ream_weight);
                                setlossReams(data1[0].loss_ream);
                                setNumberOfReams(data1[0].total_ream);
                                GetLineItemDetails(data[0].id_child_roll, true);

                                callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_LIST, 'POST', { 'Content-Type': 'application/json' }, reamData)
                                    .then(data2 => {
                                        if (data2 && data2.length > 0) {
                                            // Update state with fetched data
                                            setApprovedPalletNumber(data2);
                                            setDisableSaveBtn(true);
                                            setDisbleSheetValue(true);
                                            setPalletStatus('Completed')
                                            setViewReamsList(true);


                                            // Check if all rows have the status "approved"
                                            const allApproved = data.every(detail => detail.status === 'approved');

                                            // Set enableReverse based on whether all statuses are approved
                                            if (allApproved) {
                                                setEnableReverseProcess(false);
                                            }
                                            else {
                                                setEnableReverseProcess(true);
                                            }

                                            const orderData = {
                                                p_companyid: localStorage.getItem('companyid'),
                                                p_ream_number: '',
                                                p_mode: 1,
                                                p_pallet_id: value.pld_id
                                            };

                                            setBundleListLoading(true);

                                            callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                                                .then(data3 => {
                                                    if (data3 && data3.length > 0) {
                                                        setReamList(data3);
                                                        setBundleListLoading(false);
                                                    }
                                                })
                                                .catch(error => {
                                                    alert(error.message);
                                                });

                                        }
                                    })
                                    .catch(error => {
                                        // Update state with error message       
                                        setSheeterSeverityvalue('error');
                                        setSheeterMessageValue(error.message);
                                        setSheeterAlertTitleValue('Error');
                                        setSheeterMsgOpen(true);
                                    });
                            }
                            else {
                                GetLineItemDetails(data[0].id_child_roll, false);
                            }
                        })
                        .catch(error => {
                            // Update state with error message       
                            setSheeterSeverityvalue('error');
                            setSheeterMessageValue(error.message);
                            setSheeterAlertTitleValue('Error');
                            setSheeterMsgOpen(true);
                        });



                }


            })
            .catch(error => {
                alert(error.message);
            });




    }

    const CalculateReamValue = (e) => {
        setNumberOfSheets(e.target.value);
        calculateReamsCount(e.target.value);

    }

    const calculateReamsCount = (sheets) => {
        // // calculate number of reams
        // let numberofReams = parseInt(allocatedSheets / sheets);
        // setNumberOfReams(numberofReams); // convert to integer

        // let balancesheets = allocatedSheets - (numberofReams * sheets);
        // let chk_orginal = parseInt(allocatedSheets);
        // let lreams = 0;
        // setlossReams(0);
        // if (balancesheets < chk_orginal) {
        //     if (balancesheets > 0) {
        //         setlossReams(1);
        //         lreams = 1;
        //     }

        // }

        // let ReamWeight = (palletWeight / allocatedSheets) * sheets;
        // ReamWeight = parseFloat(ReamWeight.toFixed(2));

        // let LReamwt = (palletWeight / allocatedSheets) * balancesheets; //(palletWeight - (ReamWeight * numberofReams));
        // LReamwt = parseFloat(LReamwt.toFixed(2));

        // setLReamWeight(LReamwt)
        // setReamWeight(ReamWeight);
        // setTotalReams(numberofReams + lossReams);
        // setBalanceSheet(balancesheets);
    }


    // save reams 
    const createReams = () => {


        if (numberofReams === 0 && sheeterNoOfSheets === 0) {
            setSheeterSeverityvalue('info');
            setSheeterMessageValue('No Reams Available to create.');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);

            return;
        }

        const parameter = {
            p_companyid: localStorage.getItem('companyid'),
            p_plant_id: 1,
            p_shift_id: winderShiftID,
            p_shift_date: dayjs(winderShiftDate).format('YYYY-MM-DD hh:mm:ss'),
            p_id_operator: operatorID,
            p_pallet_list: selectedReelList,
            p_total_sheets: numberofSheets,
            p_total_reams: numberofReams,
            p_ream_sheets: sheeterNoOfSheets,
            p_ream_weight: reamWeignt,
            p_lose_reams: lossReams,
            p_lose_ream_sheets: balanceSheet,
            p_lose_ream_weight: lReamWeignt,
            p_user: 'thiravidam'

        };

        // create reams                   
        callApi(API_ENDPOINTS.PROD_MANAGEMENT_CREATE_REAM_USING_MULTIPLE_PALLET, 'POST', { 'Content-Type': 'application/json' }, parameter)
            .then(data => {
                if (data && data.length > 0) {
                    setApprovedPalletNumber(data);
                    //setviewSheeterchildRollSummaryDetail(true);
                    setSheeterSeverityvalue('info');
                    setSheeterMessageValue('Ream number created .');
                    setSheeterAlertTitleValue('info');
                    setSheeterMsgOpen(true);

                    setViewReamsList(true);
                    setDisableSaveBtn(true);
                    setDisbleSheetValue(true);
                    setPalletStatus('Completed')

                    let id_ream_hdr = data[0].id_hdr;


                    const reamFilter = {
                        p_companyid: localStorage.getItem('companyid'),
                        p_ream_number: '',
                        p_mode: 1,
                        p_pallet_id: id_ream_hdr
                    };

                    setBundleListLoading(true);

                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, reamFilter)
                        .then(reamdata => {
                            if (reamdata && reamdata.length > 0) {
                                setReamList(reamdata);
                                setViewReamQRCode(true);
                                setBundleListLoading(false);
                            }
                        })
                        .catch(error => {
                            alert(error.message);
                        });


                }
                else {
                    setSheeterSeverityvalue('info');
                    setSheeterMessageValue('Unable create Reams Number.');
                    setSheeterAlertTitleValue('info');
                    setSheeterMsgOpen(true);
                    //setviewSheeterchildRollSummaryDetail(false);
                }
            })
            .catch(error => {
                alert(error.message);
                // Update state with error message        
                setSheeterSeverityvalue('error');
                setSheeterMessageValue(error.message);
                setSheeterAlertTitleValue('Error');
                setSheeterMsgOpen(true);

            });
    }

    const ReverseReams = () => {
        setSheeterMsgOpen(false);
        let isvalid = true;
        let validation_msg = '';

        // validation Process

        if (numberofSheets === 0) {
            validation_msg += 'Please Enter Number of Sheets in Reams.\n';
            isvalid = false;
        }

        // Remove trailing newline character if any
        validation_msg = validation_msg.trim();

        if (isvalid == true) {

            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_total_reams: totalReams,

            };


            // GET REAM NUMBER
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_NUMBER, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {

                    // update ream number to ream table
                    if (data && data.length > 0) {
                        // preceed to add new reams
                        console.table(data);
                        let ream_number_end = data[0].lot_number;
                        let ream_number_start = ream_number_end - totalReams;


                        const reamData = {
                            p_companyid: localStorage.getItem('companyid'),
                            p_plant_id: 1,
                            p_total_reams: numberofReams,
                            p_pallet_id: palletID,
                            p_number_of_sheets: numberofSheets,
                            p_loss_reams: lossReams,
                            p_loss_reams_sheets: balanceSheet,
                            p_created_by: localStorage.getItem('userID'),
                            p_reject_ream_status: false,
                            p_ream_number_start: ream_number_start,
                            p_ream_weight: reamWeignt,
                            p_l_ream_weight: lReamWeignt,
                            p_process_id: 1
                        };


                        // create reams                   
                        callApi(API_ENDPOINTS.PROD_MANAGEMENT_CREATE_REAM, 'POST', { 'Content-Type': 'application/json' }, reamData)
                            .then(data => {
                                if (data && data.length > 0) {
                                    // setApprovedPalletNumber(data);
                                    // //setviewSheeterchildRollSummaryDetail(true);
                                    // setSheeterSeverityvalue('info');
                                    // setSheeterMessageValue('Ream number created .');
                                    // setSheeterAlertTitleValue('info');
                                    // setSheeterMsgOpen(true);

                                    // setViewReamsList(true);
                                    // setDisableSaveBtn(true);
                                    // setDisbleSheetValue(true);
                                    // setPalletStatus('Completed')
                                    setSheeterSeverityvalue('info');
                                    setSheeterMessageValue('Ream number reverse process failed.');
                                    setSheeterAlertTitleValue('info');
                                    setSheeterMsgOpen(true);

                                }
                                else {
                                    setApprovedPalletNumber([]);
                                    setSheeterSeverityvalue('info');
                                    setSheeterMessageValue('Ream number reverse process success.');
                                    setSheeterAlertTitleValue('info');
                                    setSheeterMsgOpen(true);
                                    setViewReamsList(false);
                                    setDisableSaveBtn(false);
                                    setDisbleSheetValue(false);
                                    setPalletStatus('wip')
                                    //setviewSheeterchildRollSummaryDetail(false);
                                }
                            })
                            .catch(error => {
                                alert(error.message);
                                // Update state with error message        
                                setSheeterSeverityvalue('error');
                                setSheeterMessageValue(error.message);
                                setSheeterAlertTitleValue('Error');
                                setSheeterMsgOpen(true);
                                //setviewSheeterchildRollSummaryDetail(false);
                            });
                    }
                    else {
                        // set error message
                        alert('no data found..');
                    }

                })
                .catch(error => {
                    // Update state with error message       
                    setSheeterSeverityvalue('error');
                    setSheeterMessageValue(error.message);
                    setSheeterAlertTitleValue('Error');
                    setSheeterMsgOpen(true);
                });

        }
        else {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue(validation_msg);
            setSheeterAlertTitleValue('Error');
            setSheeterMsgOpen(true);
        }

    };


    const filterData = (filter) => {
        let fromDate, toDate;
        switch (filter) {
            case 'All':
                fromDate = dayjs().subtract(4, 'year').startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'Today':
                fromDate = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Week':
                fromDate = dayjs().startOf('week').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('week').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Month':
                fromDate = dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Quarter':
                fromDate = dayjs().startOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Year':
                fromDate = dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss');
                break;
            default:
                fromDate = ''; // You can set a default value here
                toDate = ''; // You can set a default value here
                break;
        }

        setSheeterMsgOpen(false);
        setViewReamLabeling(false);
        setShowCard(false);
        setSheeterSelectedChildRoll(null);

        // Date filter
        const p_companyid = localStorage.getItem('companyid');
        const p_frommodate = fromDate;//dayjs(orderFromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = toDate;//dayjs(orderToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_filtertype = "ream";
        const p_mono = 1;

        // Collect the values of the controls
        const parameter = {
            p_companyid,
            p_frommodate,
            p_tomodate,
            p_filtertype,
            p_mono,
        };

    };

    const callError = (serverityval, msg, title) => {
        // Update state with error message        
        setSheeterSeverityvalue(serverityval);
        setSheeterMessageValue(msg);
        setSheeterAlertTitleValue(title);
        setSheeterMsgOpen(true);
    };



    const getSelectedReamDetail = (event, value) => {

        if (value && value != null) {
            setSelectedReam(value);
            //const reamDetails = approvedPalletNumber.find(bundle => bundle.ream_number === value.ream_number);
            const reamDetails = reamList.find(bundle => bundle.ream_number === value.ream_number);
            setSelectedReamDetailsQR(reamDetails);
            setViewQRCodeDetails(true);
        }
        else {

            setViewQRCodeDetails(false);
        }
    };

    const [isDataLoadeds, setIsDataLoadeds] = useState(false);

    useEffect(() => {
        if (!isDataLoadeds) {

            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_frommodate: FromShiftDate,
                p_tomodate: ToShiftDate,
            }
            setLoading(true);
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_BUNDLE_PROCESS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setSummaryList(data);
                        setLoading(false);
                    }
                    else { setLoading(false); }
                })
                .catch(error => {
                    alert(error.message);
                    setLoading(false);
                });

        }
    }, [isDataLoadeds, FromShiftDate, ToShiftDate, setFromShiftDate, setToShiftDate]);

    const LoadJobList = () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_frommodate: FromShiftDate,
            p_tomodate: ToShiftDate,
        }
        setLoading(true);
        callApi(API_ENDPOINTS.PROD_MANAGEMENT_BUNDLE_PROCESS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setSummaryList(data);
                    setLoading(false);
                }
                else { setLoading(false); }
            })
            .catch(error => {
                alert(error.message);
                setLoading(false);
            });
    }


    const [headerData, setheaderData] = useState({
        logo: process.env.PUBLIC_URL + '/ITC_logo.png',

    });



    const handleButtonClick = async (buttonName) => {
        setSelectedButton(buttonName);
        setSheeterMsgOpen(false);

        // let printselectedPalletDetails = approvedPalletNumber;
        let printselectedBundleDetails = reamList;
        let isvalid = true;

        if (printselectedBundleDetails.length === 0) {
            isvalid = false;
        } else if (buttonName === "PrintQR" && (!selectedReamDetails || selectedReamDetails.length === 0)) {
            isvalid = false;

            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select pallet code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
        }

        let company_id = localStorage.getItem('companyid');

        // filter data      
        printselectedBundleDetails = reamList.filter((ream) => selectedReamRows.includes(ream.id_bundle_val));

        if (printselectedBundleDetails.length === 0) {
            isvalid = false;
            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select ream code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
            return;
        }


        if (isvalid == true) {
            if (printselectedBundleDetails.length > 0) {
                const printWindow = window.open('', '_blank');
                try {
                    // Generate HTML content for each QR code
                    for (const qrCodeValue of printselectedBundleDetails) {
                        // Generate QR code data URL
                        const qrDataUrl = await generateQRCode(qrCodeValue.bundle_number);
                        // Check if QR code generation was successful
                        if (!qrDataUrl) {
                            console.error('Error generating QR code for value:', qrCodeValue.bundle_number);
                            continue; // Skip to the next QR code
                        }


                        if (company_id === '1') {

                            // Write HTML content for the QR code to the print window
                            printWindow.document.write(`
                        
                        <html>
                                <head>
                                    <title>Printed Report</title>
                                    <style>
                                        body {
                                            margin: 0;
                                            padding: 0;
                                            font-family: Arial, sans-serif;
                                        }
                                        .container {
                                            display: flex;
                                            align-items: center;
                                            justify-content: space-between;
                                            padding: 10px;
                                            border: 1px solid #ccc;
                                            box-sizing: border-box;
                                        }
                                        .qr-code {
                                            width: 150px; /* Adjust as needed */
                                        }
                                        .bundle-details {
                                            flex: 1;
                                            margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                                        }
                                        .bundle-details h5 {
                                            margin: 0;
                                            font-size: 18px;
                                        }
                                        .details-table {
                                            display: grid;
                                            grid-template-columns: 150px auto;
                                            gap: 10px 20px;
                                            margin-top: 10px;
                                        }
                                        .details-table div {
                                            font-size: 16px;
                                        }
                                        .details-table .label {
                                            font-weight: bold;
                                        }
                                        .bundle-details hr {
                                            margin: 10px 0;
                                            border: 1px solid #ccc;
                                        }
                                        /* Ensure each container goes on a new page */
                                        .container {
                                            page-break-after: always;
                                        }
                                    </style>
                                </head>
                                <body>
                                    <div class="container">
                                        <div>
                                            <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                                            <h4 >${qrCodeValue.bundle_number || 'XXXXXX0123'}</h4>
                                        </div>
                                        <div class="bundle-details">
                                            <h5>BUNDLE DETAILS</h5>
                                            <hr/>
                                            <div class="details-table">
                                                <div class="label">DATE / SHIFT </div><div>:  ${qrCodeValue.shift_date} / ${qrCodeValue.shift_code}</div>  
                                                <div class="label">QUALITY</div><div>: ${qrCodeValue.item_code}</div>   
                                                <div class="label">REEL NO</div><div>: ${qrCodeValue.cr_number || '0'}</div>  
                                                <div class="label">BUNDLE NO</div><div>: ${qrCodeValue.bundle_number}</div>  
                                                <div class="label">BUNDLE WT (KG)</div><div>: ${qrCodeValue.bundle_weight || 0}</div>     
                                                <div class="label">REAMS/BUNDLE</div><div>: ${qrCodeValue.no_of_reams || 0}</div>                        
                                                <div class="label">GRAIN</div><div>: ${qrCodeValue.grain || ''}</div>                                            
                                                <div class="label">MA NO</div><div>: ${qrCodeValue.lot_no || ''}</div>
                                                <div class="label">SO NO</div><div>: ${qrCodeValue.indent_no || ''}</div>
                                                <div class="label">CUSTOMER</div><div>: ${qrCodeValue.customer_name || ''}</div>
                                                <div class="label">SUPPLIER</div><div>: ${qrCodeValue.supplier_name || ''}</div>
                                                <div class="label">GSM</div><div>: ${qrCodeValue.gsm || ''}</div>
                                                <div class="label">SIZE</div><div>: ${qrCodeValue.size || ''}</div> 
                                            </div>
                                        </div>
                                    </div>
                                </body>
                            </html>
                        
                            
                        `);
                        }
                        else if (company_id === '13') {

                            printWindow.document.write(`
                            <html>
                            <head>
                                <title>Label Printing</title>
                                <style>
                                    @page {
                                         size: 100mm 75mm; /* Portrait orientation */
                                         margin: 0; /* Remove margins for edge-to-edge printing */
                                    }
                                    body {
                                        margin: 0;
                                        padding: 0;
                                        font-family: Arial, sans-serif;
                                        display: flex;
                                        flex-direction: column;
                                        align-items: flex-start;
                                        justify-content: flex-start;
                                        box-sizing: border-box;
                                    }
                                    .label {
                                        width: 100mm;
                                        height: 75mm;
                                        padding: 3mm;
                                        box-sizing: border-box;
                                        
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: space-between;
                                       
                                    }
                                    .label{                                       
                                        page-break-after: always; /* Ensure each label starts on a new page */                                
                                    }    
                                    .container {
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        width: 100%;
                                        height: 35px;
                                        padding: 0; /* Remove padding from the container */
                                        box-sizing: border-box;
                                        margin-top:2mm;
                                    }
    
                                    .container1 {
                                            display: flex;
                                            align-items: center;
                                            justify-content: space-between;
                                            width: 100%;
                                            height: 0px;
                                            padding: 0;
                                                margin: 0; /* No external space */
                                            box-sizing: border-box;
                                            font-size: 2rem;
                                            font-weight: bold;
                                            
                                        }

                                        .container2 {
                                            display: flex;
                                            align-items: center;
                                            justify-content: space-between;
                                            width: 100%;
                                            height: 1px;
                                            padding: 0;
                                            box-sizing: border-box;
                                            font-size: 6rem;
                                            font-weight: bold;
                                           
                                        }
                                    .logo {
                                        max-width: 50mm; /* Ensure logo scales within a small area */
                                        height: auto;
                                        margin-left: 1mm;
                                    }
                                    .text-details {
                                        flex: 1;
                                        margin-left: 1mm;
                                        margin-top: 0.2mm;
                                        font-size: 0.4rem;
                                        font-weight: bold;
                                    }
                                    .text-details p {
                                        margin: 0;
                                        line-height: 1.1; /* Reduce line spacing for compactness */
                                        font-weight: bold;
                                        color: #01579b;
                                    }
                                    .marketed-by {
                                        text-align: center;
                                        font-size: 0.2rem;
                                        font-weight: bold;
                                        margin-top: 0.5mm; /* Reduce or remove space above */
                                        margin-left:0.5mm;
                                    }
                                    .marketed-by p {
                                        margin: 0; /* Remove margins from paragraphs */
                                        line-height: 1.1; /* Compact line spacing */
                                    }
    
                                    .marketed-by2 {
                                        text-align: left;
                                        font-size: 0.6rem;
                                        font-weight: bold;
                                        margin-top: -1mm; /* Reduce or remove space above */
                                        margin-left:1mm;
                                    }

                                      .marketed-by3 {
                                        text-align: left;
                                        font-size: 0.6rem;
                                        font-weight: bold;
                                    
                                        width:50%;

                                          padding: 0;
                                                margin: 0; /* No external space */
                                    }
                                        

                                    .marketed-by2 p {
                                        margin: 0; /* Remove margins from paragraphs */
                                        line-height: 0.5; /* Compact line spacing */
                                    }
                                     .marketed-by1 {
                                        text-align: center;
                                        font-size: 0.8rem;
                                        font-weight: bold;
                                        margin-top: -1mm; /* Reduce or remove space above */
                                        margin-left:1mm;
                                    }

                                      .marketed-by1 p {
                                        margin: 0; /* Remove margins from paragraphs */
                                        line-height: 0.5; /* Compact line spacing */
                                    }
                                    .logo {
                                        max-width: 10mm;
                                        height: auto;
                                    }
                                    .text-details p, .marketed-by p, .details-section .label, .details-section .value {
                                        margin: 0;
                                        font-size: 0.5rem; /* Adjust for readability */
                                        line-height: 1.2;
                                    }
                                    
                                    .details-section {
                                        display: flex;
                                        flex-wrap: wrap;
                                        gap: 2mm;
                                    }
                                    .details-section .label, .details-section .value {
                                        flex: 1 1 45%; /* Adjust for label and value alignment */
                                    }
                                </style>
                            </head>
                            <body>
                                <div class="label">
                                    <div class="header-row">
                                        <div class="container">
                                            <!-- Logo Section -->
                                            <div>
                                                
                                            </div>
    
                                            <!-- Text Details -->
                                            <div class="text-details">
                                               
                                            </div>
    
                                            <div class="marketed-by">
                                                
                                            </div>
                                        </div>
                                    </div>

                                     <!-- Detail header-->
                                    <table border="0" style="width: 100%; border-collapse: collapse; text-align: left;">
                                    <thead>
                                        <tr style="font-size: 14px">
                                            <th style="font-weight: normal;text-align: left;">PRODUCT</th>
                                            <th style="font-weight: normal;text-align: center;">GRAIN</th>
                                            <th style="font-weight: normal;text-align: center;">GSM</th>
                                            <th style="font-weight: normal;text-align: center;">SIZE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="font-size: 14px;font-weight: bold;">
                                            <td >${qrCodeValue.item_code}</td>
                                            <td style="text-align: center;">${qrCodeValue.grain}</td>
                                            <td style="text-align: center;">${qrCodeValue.gsm}</td>
                                            <td style="text-align: center;">${qrCodeValue.size}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                                <table border="0" style="width: 100%; border-collapse: collapse; text-align: left; margin-top: 5px;">
                                    <thead>
                                        <tr style="font-size: 12px;">
                                            <th style="font-weight: normal;text-align: left;">NO OF REAM</th>
                                            <th style="font-weight: normal;text-align: center;">GROSS WEIGHT (KG)</th>
                                            <th style="font-weight: normal;text-align: center;">NET WEIGHT (KG)</th>
                                            <th style="font-weight: normal;text-align: center;">REAM WEIGHT (KG)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr style="font-size: 14px;font-weight: bold;text-align: center;">
                                        <td style="width: 30%;">${qrCodeValue.no_of_reams}</td>
                                        <td style="width: 30%;">${((qrCodeValue.bundle_weight || 0) + (packingWeight || 0)).toFixed(1)}
                                        </td>
                                        <td style="width: 30%;">${(qrCodeValue.bundle_weight || 0).toFixed(1)}
                                        </td>
                                        <td style="width: 20%;">${(qrCodeValue.ream_weight || 0).toFixed(1)}
                                        </td>
                                    </tr>
                                
                                    </tbody>
                                </table>
                                
                                <table border="0" style="width: 100%; border-collapse: collapse; text-align: left; margin-top: 5px;">
                                    <thead>
                                        <tr style="font-size: 12px;">
                                            <th style="font-weight: normal;text-align: left;">BUNDLE NUMBER</th>
                                            <th style="font-weight: normal;text-align: center;">LOT NO.</th>
                                            <th style="font-weight: normal;text-align: center;">PRODUCTION DATE</th>
                                            <th style="font-weight: normal;text-align: center;">COUNTRY ORIGIN</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="font-size: 14px;font-weight: bold;">
                                            <td>${qrCodeValue.bundle_number}</td>
                                            <td >${qrCodeValue.pr_number}</td>
                                            <td style="text-align: center;">${qrCodeValue.shift_date}</td>
                                            <td style="font-size: 12px;">MADE IN INDIA</td>
                                        </tr>
                                    </tbody>
                                </table>                                 
                                   


                                </div>
                                <!-- Duplicate label blocks for additional labels -->
                            </body>
                            </html>
                        `);

                        }

                    }
                    // Close the print window and print the report

                    printWindow.document.close();
                    printWindow.print();

                } catch (error) {
                    console.error('Error handling button click:', error);
                }
            }


        }

    };

    //  <td style="width: 30%;">${qrCodeValue.bundle_weight + packingWeight}</td>
    //                                         <td style="width: 30%;">${qrCodeValue.bundle_weight}</td>
    //                                         <td style="width: 20%;">${qrCodeValue.ream_weight}</td>




    //     <table border="0" style="width: 100%; border-collapse: collapse; text-align: left; margin-top: 5px;">
    //     <thead>
    //         <tr style="font-size: 12px;">
    //             <th style="font-weight: normal;text-align: left;">NO OF REAM</th>
    //             <th style="font-weight: normal;text-align: center;">GROSS WEIGHT (KG)</th>
    //             <th style="font-weight: normal;text-align: center;">NET WEIGHT (KG)</th>
    //             <th style="font-weight: normal;text-align: center;">REAM WEIGHT (KG)</th>
    //         </tr>
    //     </thead>
    //     <tbody>
    //     <tr style="font-size: 14px;font-weight: bold;text-align: center;">
    //         <td style="width: 30%;">${qrCodeValue.no_of_reams}</td>
    //         <td style="width: 30%;">${qrCodeValue.bundle_weight + 0.500}</td>
    //         <td style="width: 30%;">${qrCodeValue.bundle_weight}</td>
    //         <td style="width: 20%;">${qrCodeValue.ream_weight}</td>
    //     </tr>

    //     </tbody>
    // </table>

    // <table border="0" style="width: 100%; border-collapse: collapse; text-align: left; margin-top: 5px;">
    //     <thead>
    //         <tr style="font-size: 12px;">
    //             <th style="font-weight: normal;text-align: left;">BUNDLE NUMBER</th>
    //             <th style="font-weight: normal;text-align: center;">LOT NO.</th>
    //             <th style="font-weight: normal;text-align: center;">PRODUCTION DATE</th>
    //             <th style="font-weight: normal;text-align: center;">COUNTRY ORIGIN</th>
    //         </tr>
    //     </thead>
    //     <tbody>
    //         <tr style="font-size: 14px;font-weight: bold;">
    //             <td>${qrCodeValue.bundle_number}</td>
    //             <td >${qrCodeValue.pr_number}</td>
    //             <td style="text-align: center;">${qrCodeValue.shift_date}</td>
    //             <td style="font-size: 12px;">MADE IN INDIA</td>
    //         </tr>
    //     </tbody>
    // </table>




    {/* <div>
                                    <table style="text-align: left; font-size: 10px; border-collapse: collapse;">
                                        <tr>
                                            <!-- Column 1 -->
                                            <th >
                                                <table style="text-align: left; font-size: 10px;">
                                                    <tr style="text-align: center; font-weight: lighter;">
                                                        <td style="text-align: left;">PRODUCT</td>                            
                                                        <td>GRAIN</td>
                                                        <td>GSM</td>
                                                        <td>SIZE (cm)</td>
                                                    </tr>
                                                    <tr style="text-align: center; font-weight: bold;">
                                                        <td style="text-align: left; font-weight: bold;">${qrCodeValue.item_code}</td>
                                                        <td >${qrCodeValue.grain}</td>
                                                        <td>${qrCodeValue.gsm}</td>
                                                        <td>${qrCodeValue.size}</td>
                                                    </tr>
                                                    <tr style="text-align: center; font-weight: lighter;">
                                                        <td style="text-align: left;">NO OF REAM</td>                            
                                                        <td>GROSS WT </td>
                                                        <td>NET WT </td>
                                                        <td>REAM WT </td>
                                                    </tr>
                                                    <tr style="text-align: center; font-weight: lighter;">
                                                        <td></td>                            
                                                        <td>(kg)</td>
                                                        <td>(kg)</td>
                                                        <td>(kg)</td>
                                                    </tr>
                                                    <tr style="text-align: center; font-weight: bold;">
                                                        <td style="text-align: center;">${qrCodeValue.no_of_reams}</td>
                                                        <td>${qrCodeValue.bundle_weight + 0.500}</td>
                                                        <td>${qrCodeValue.bundle_weight}</td>
                                                        <td>${qrCodeValue.ream_weight}</td>
                                                    </tr>
                                                    <tr style="text-align: center; font-weight: lighter;">
                                                        <td style="text-align: left;">BUNDLE NO</td>                            
                                                        <td>LOT NO</td>
                                                        <td>PROD.DATE</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr style="text-align: center;">
                                                        <th style="text-align: left;">${qrCodeValue.bundle_number}</th>                            
                                                        <th>${qrCodeValue.pr_number}</th>
                                                        <th>${qrCodeValue.shift_date}</th>
                                                        <th style="font-size:12px ;">MADE IN INDIA</th>
                                                    </tr>
                                                
                                                </table>
                                            </th>                
                                            
                                        </tr>
                                    </table>
                                </div> */}


    // Function to generate QR code as data URL
    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };



    const [open, setOpen] = useState(false);
    const [getRejectResult, setGetRejectResult] = useState([]);

    const openpopup = async (buttonName) => {
        setSelectedButton(buttonName);
        if (buttonName == 'ReverseProcess') {
            ReverseReams();
        }
        else if (buttonName == 'RejectChild') {
            setOpen(true);
        }
    }

    const closepopup = () => {
        setOpen(false);
        setSheeterMsgOpen(false);


        let reject_product_type = "Ream";
        let product_code = selectedReamDetailsQR.ream_number;
        let isvalid = true;

        if (enableReject == false) {
            isvalid = false;
        }
        else if (product_code === "") {
            isvalid = false;
        }
        else if (selectedReamDetailsQR.ream_number == "") {
            isvalid = false;
        }
        else if (selectedReamDetailsQR.status != "approved") {

            isvalid = false;
            if (selectedReamDetailsQR.status == "rejected") {
                setSheeterSeverityvalue('info');
                setSheeterMessageValue('Ream already rejected');
                setSheeterAlertTitleValue('info');
                setSheeterMsgOpen(true);
            }
            else {
                setSheeterSeverityvalue('info');
                setSheeterMessageValue('We cannot reject this ream. The ream has already been processed for the next stage.');
                setSheeterAlertTitleValue('info');
                setSheeterMsgOpen(true);
            }

        }


        if (isvalid) {
            // call reject reel process
            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_reject_product_type: reject_product_type,
                p_product_code: product_code,
                p_rejectReasonID: rejectReasonID,
                p_rejectRemarks: rejectRemarks,
                p_user: "netique",
            };

            callApi(API_ENDPOINTS.DECKL_UPDATE_REJECT_REEL, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        setGetRejectResult(data);
                        setSheeterSeverityvalue('info');
                        setSheeterMessageValue('The ream has rejected.');
                        setSheeterAlertTitleValue('info');
                        setSheeterMsgOpen(true);
                        getReamList();
                    }
                })
                .catch(error => {

                });
        }
    }


    const getReamList = () => {
        //parameters
        const reamData = {
            p_companyid: localStorage.getItem('companyid'),
            p_pallet_id: palletID,
        };


        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_LIST, 'POST', { 'Content-Type': 'application/json' }, reamData)
            .then(data => {
                if (data && data.length > 0) {
                    setApprovedPalletNumber(data);

                    const orderData = {
                        p_companyid: localStorage.getItem('companyid'),
                        p_ream_number: '',
                        p_mode: 1,
                        p_pallet_id: palletID
                    };

                    setBundleListLoading(true);

                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                        .then(data => {
                            if (data && data.length > 0) {
                                setReamList(data);
                                setBundleListLoading(false);
                            }
                        })
                        .catch(error => {
                            alert(error.message);
                        });

                }

            })
            .catch(error => {
                alert(error.message);
                // Update state with error message        
                setSheeterSeverityvalue('error');
                setSheeterMessageValue(error.message);
                setSheeterAlertTitleValue('Error');
                setSheeterMsgOpen(true);
                //setviewSheeterchildRollSummaryDetail(false);
            });
    };

    const filteredReamData = reamList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All') {
            //|| row.status === selectedStatus
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });





    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).replace(/ /g, "-"); // Replace spaces with hyphens
    };


    // Load child roll details
    const [childRollDetails, setChildRollDetails] = useState([]);

    const GetLineItemDetails = async (id_child_roll, edit) => {

        if (id_child_roll != 0) {
            try {
                const para = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_id_child_reel: id_child_roll
                };

                // Await the API response
                const data = await callApi(
                    API_ENDPOINTS.WAREHOUSE_GET_STACK_WISE_ALLOCATED_REEL_COMPLETE_DETAIL,
                    'POST',
                    { 'Content-Type': 'application/json' },
                    para
                );

                if (data && data.length > 0) {
                    setChildRollDetails(data);
                    setviewSheeterchildRollDetail(true);

                    // update then hide this
                    if (edit === false) {
                        setNumberOfSheets(data[0].no_of_sheets)
                        calculateReamsCount(data[0].no_of_sheets);
                    }

                }
                else {
                    setviewSheeterchildRollDetail(false);
                }
            } catch (error) {
                alert(error);
            }
        }

    }
    const [showCard, setShowCard] = useState(false);

    const handleHide = () => {
        setShowCard(false);
        // setViewAvailableSlots(true);
        // SetViewAvailableReelList(false);
    };


    const [partyList, setPartyList] = useState([]);



    const LoadOrderItemDetailsFilterByCONumber = (indent_no) => {

        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_indent_no: indent_no
        };

        setLoadingOrderItemDet(true);
        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_ORDER_LINE_ITEMS_DETAILS_BY_CONUMBER, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setViewLineItemList(true);
                    setLoadingOrderItemDet(false);
                } else {
                    // No data found
                    setPartyList([]);
                    setViewLineItemList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                    setLoadingOrderItemDet(false);
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
                setLoadingOrderItemDet(false);
            });
    }

    const LoadOrderItemDetails = (FromDate, ToDate) => {
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_mono = 0;
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: p_mono,
            p_frommodate,
            p_tomodate
        };

        setLoadingOrderItemDet(true);
        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setViewLineItemList(true);
                    setLoadingOrderItemDet(false);
                } else {
                    // No data found
                    setPartyList([]);
                    setViewLineItemList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                    setLoadingOrderItemDet(false);
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
                setLoadingOrderItemDet(false);
            });
    }

    const LoadOrderItemDetailsWithoutLoadProgressing = (FromDate, ToDate) => {
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_mono = 0;
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: p_mono,
            p_frommodate,
            p_tomodate
        };


        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setViewLineItemList(true);
                    setLoadingOrderItemDet(false);
                } else {
                    // No data found
                    setPartyList([]);
                    setViewLineItemList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                    setLoadingOrderItemDet(false);
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
                setLoadingOrderItemDet(false);
            });
    }

    // useEffect(() => {

    //       LoadOrderItemDetails();



    // }, [FromDate,ToDate]);

    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    useEffect(() => {
        const fetchChildRollDetails = async () => {
            if (period === 'Today') {
                filterData('Today');
            }

        };

        fetchChildRollDetails();

    }, [setPeriod]);

    const [newJob, setNewJob] = useState(false);
    const [viewJob, setViewJob] = useState(true);
    const [viewLineItemList, setViewLineItemList] = useState(false);
    const [viewPalletList, setviewPalletList] = useState(false);
    const [viewReamProcess, setviewReamProcess] = useState(false);
    const [reelList, setReelList] = useState([]);
    const [selectedReelList, setSelectedReelList] = useState([]);
    const [jobID, setJobID] = useState(0);
    const [selectedLineItemDetail, setSelectedLineItemDetail] = useState([]);
    const [selectedOrderItems, SetselectedOrderItems] = useState([]);
    const [uniqueCrNumbers, setUniqueCrNumbers] = useState([]);

    const handleCallEdit = (row) => {
        SetselectedOrderItems(row);

        setSelectedChip('View Reel List');

        if (row.indent_no && partyList && Array.isArray(partyList)) {
            let lineItems = partyList.filter((l) => l.indent_no === row.indent_no && l.line_no === row.line_no);
            reamCalculation(lineItems);
        }
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_indent_no: row.indent_no,
            p_line_no: row.line_no,
            p_release_no: 0,

        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT__GET_ORDER_LINE_ITEMS_WISE_REAM_LIST, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {

                    const allConverted = data.every(row => row.status === 'converted');
                    if (!allConverted) {
                        setReelList(data);
                        setviewPalletList(true);
                        setViewLineItemList(false);

                        // Extract unique cr_number values
                        const uniqueCrNumbers = [...new Set(data.map((item) => item.cr_number))];
                        setUniqueCrNumbers(uniqueCrNumbers);

                        setFilteredReelData(data);
                    }
                    else {
                        setReelList([]);
                        setviewPalletList(false);
                        callError('info', 'No data found, Kindly adjust data range.', 'info');
                        LoadOrderItemDetailsWithoutLoadProgressing(FromDate, ToDate);
                        setUniqueCrNumbers([]);
                        setFilteredReelData([]);
                    }
                } else {
                    // No data found
                    setReelList([]);
                    setFilteredReelData([]);
                    setviewPalletList(false);
                    LoadOrderItemDetailsWithoutLoadProgressing(FromDate, ToDate);
                    setUniqueCrNumbers([]);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                }
            })
            .catch(error => { callError('error', error.message, 'Error'); });

    };

    const reamCalculation = (lineItems) => {
        let sheets = lineItems[0].no_of_sheets;

        // Summing the no_of_sheets using reduce
        //let totalSheets = lineItems.reduce((acc, item) => acc + item.no_of_sheets, 0);

        setSelectedLineItemDetail(lineItems);
        setSheeterNoOfSheets(sheets);
    };

    // const filteredReelData = reelList.filter((row) => {
    //     // Check if row matches selected status
    //     if (selectedStatus === 'All' || row.status === selectedStatus) {
    //         // Check if all filter fields match
    //         return Object.keys(filters).every((key) => {
    //             if (filters[key] === '') return true; // No filter applied
    //             return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
    //         });
    //     }
    //     return false;
    // });

    // const filteredReelData = reelList.filter((row) => {
    //     if (selectedStatus === 'All' || row.status === selectedStatus) {
    //         // Check if cr_number is being filtered
    //         if (filtersNew.cr_number.length === 0) return true; // No filter applied

    //         return filtersNew.cr_number.some((filter) =>
    //             String(row.cr_number).toLowerCase().includes(filter.cr_number.toLowerCase())
    //         );
    //     }
    //     return false;
    // });

    const [filteredReelData, setFilteredReelData] = useState([]);

    const selectableRows = reelList.filter(row => row.status !== 'converted');
    const allSelected = selectedRows.length === selectableRows.length && selectableRows.length > 0;
    const someSelected = selectedRows.length > 0 && selectedRows.length < selectableRows.length;

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            // Select all selectable rows (exclude 'converted')
            let newSelectedRows;


            if (cr_number.length <= 0 || cr_number === undefined) {
                newSelectedRows = selectableRows.map(row => row.id_ream);
            }
            else {
                const filteredRows = selectableRows.filter(
                    (row) => row.cr_number === cr_number[0]
                );
                newSelectedRows = filteredRows.map(row => row.id_ream);

            }

            totalSheetsAndReam(newSelectedRows);
            setSelectedRows(newSelectedRows);
            return;
        }
        // Clear selection on uncheck
        setSelectedRows([]);
    };



    // const handleSelectAllClick = (event) => {
    //     if (event.target.checked) {
    //         // const newSelectedRows = reelList.map((row) => row.id_ream);

    //         const newSelectedRows = filteredReelData
    //             .filter((row) => row.status !== 'converted') // Exclude 'converted' rows
    //             .map((row) => row.id_ream);

    //         totalSheetsAndReam(newSelectedRows);
    //         setSelectedRows(newSelectedRows);
    //         return;
    //     }
    //     setSelectedRows([]);
    // };



    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        totalSheetsAndReam(newSelectedRows);
        setSelectedRows(newSelectedRows);

    };
    const handleRowClick = (event, id, status) => {
        if (status === 'converted') return;
        handleRowCheckboxClick(event, id);
    };


    const [checkedReams, setCheckedReams] = useState([]);

    const totalSheetsAndReam = (newSelectedRows) => {

        let selectedLines = [];
        if (jobID === 0) {
            selectedLines = reelList.filter((f) => newSelectedRows.includes(f.id_ream));
        }
        else {
            selectedLines = newSelectedRows;
        }

        setCheckedReams(selectedLines);

        let totalReams = selectedLines.length;  //selectedLines.reduce((acc, item) => acc + item.number_of_sheets, 0);        
        let bundleWeight = 0;

        setBundleDetails([]);
        setBundleWiseReam([]);
        // calculate number of bundles

        let total_bundle_weight = 0;
        let total_bundles = 0;
        let ream_count_in_bundle = 0;
        let ream_per_bundle = 0;
        let max_ream_count_identified = false;
        let max_reamCount_val = 0;

        selectedLines.forEach(ream => {

            total_bundle_weight += ream.ream_weight;
            ream_count_in_bundle += 1;


            if (max_ream_count_identified === false) {
                if (total_bundle_weight > maxWightBundle) {

                    total_bundles = total_bundles + 1;
                    ream_per_bundle = ream_count_in_bundle - 1;
                    max_reamCount_val = ream_per_bundle;
                    //  bundle weight calculation
                    bundleWeight = total_bundle_weight - ream.ream_weight;
                    total_bundle_weight = ream.ream_weight;
                    ream_count_in_bundle = 1;

                    //update hdr details
                    //let bWt = parseFloat(bundleWeight.toFixed(GlobalConfig.DecimalPointsBundleWeight))

                    // let bWt  = Math.round(bundleWeight * GlobalConfig.DecimalPointsBundleWeight) / GlobalConfig.DecimalPointsBundleWeight;
                    let bWt = BundleWeightRounding(bundleWeight);

                    addBundleDetails(total_bundles, bWt, ream_per_bundle, false);

                    addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                    max_ream_count_identified = true;
                }
                else {
                    addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                }
            }
            else {
                if (total_bundle_weight > maxWightBundle || ream_count_in_bundle > max_reamCount_val) {

                    total_bundles = total_bundles + 1;
                    ream_per_bundle = ream_count_in_bundle - 1;

                    //  bundle weight calculation
                    bundleWeight = total_bundle_weight - ream.ream_weight;
                    total_bundle_weight = ream.ream_weight;
                    ream_count_in_bundle = 1;

                    //update hdr details
                    //let bWt = parseFloat(bundleWeight.toFixed(GlobalConfig.DecimalPointsBundleWeight))
                    // let bWt  = Math.round(bundleWeight * GlobalConfig.DecimalPointsBundleWeight) / GlobalConfig.DecimalPointsBundleWeight;
                    let bWt = BundleWeightRounding(bundleWeight);

                    addBundleDetails(total_bundles, bWt, ream_per_bundle, false);

                    addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                }
                else {
                    addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                }
            }


        });


        // lose bundle calculation
        let lbundle = 0;
        let lbundleWeight = 0;

        if (total_bundle_weight > 0 || ream_count_in_bundle > 0) {

            if (total_bundle_weight === maxWightBundle || ream_count_in_bundle === max_reamCount_val) {
                total_bundles += 1;
                bundleWeight = total_bundle_weight;
                setlossReams(0);
                setLReamWeight(0);
            }
            else {
                lbundle = 1;
                //lbundleWeight = parseFloat(total_bundle_weight.toFixed(GlobalConfig.DecimalPointsBundleWeight));

                // lbundleWeight= Math.round(total_bundle_weight * GlobalConfig.DecimalPointsBundleWeight) / GlobalConfig.DecimalPointsBundleWeight;
                lbundleWeight = BundleWeightRounding(total_bundle_weight);

                setlossReams(1);
                setLReamWeight(lbundleWeight);

                //update hdr details
                let l_bundle_number = total_bundles + 1;
                //let bWt = parseFloat(lbundleWeight.toFixed(GlobalConfig.DecimalPointsBundleWeight))

                //let bWt= Math.round(lbundleWeight * GlobalConfig.DecimalPointsBundleWeight) / GlobalConfig.DecimalPointsBundleWeight;
                let bWt = BundleWeightRounding(lbundleWeight);
                addBundleDetails(l_bundle_number, bWt, ream_count_in_bundle, true);
            }


        }


        // bundle-weight     
        setReamWeight(BundleWeightRounding(bundleWeight));




        setTotalReams(total_bundles + lbundle);
        setNumberOfReams(total_bundles);
        setNumberOfSheets(totalReams);
        setSheeterNoOfSheets(ream_per_bundle);


    };

    const BundleWeightRounding = (bundleWeight) => {
        bundleWeight = Math.round(bundleWeight * GlobalConfig.DecimalPointsBundleWeight) / GlobalConfig.DecimalPointsBundleWeight;
        return bundleWeight;
    }

    const addBundleDetails = (bundleNumber, bundleWeight, numberOfReams, bundleStatus) => {
        const newBundle = {
            bundle_number: bundleNumber,
            bundle_weight: bundleWeight,
            number_of_reams: numberOfReams,
            bundle_status: bundleStatus
        };

        setBundleDetails(prevBundles => [...prevBundles, newBundle]);

    }

    const addReamList = (bundleNumber, reamid, reamnumber) => {
        const newBundle = {
            bundle_number: bundleNumber,
            reamid: reamid,
            reamnumber: reamnumber
        };

        setBundleWiseReam(prevBundles => [...prevBundles, newBundle]);

    }






    useEffect(() => {
        if (sheeterNoOfSheets > 0 && numberofSheets > 0) {

            setSheeterMsgOpen(false);

            let totalReams = checkedReams.length;
            let bundleWeight = 0;
            setBundleDetails([]);
            setBundleWiseReam([]);

            // calculate number of bundles
            let total_bundle_weight = 0;
            let total_bundles = 0;
            let ream_count_in_bundle = 0;
            let ream_per_bundle = 0;
            let maximum_bundle_limit = parseInt(sheeterNoOfSheets);

            checkedReams.forEach(ream => {

                total_bundle_weight += ream.ream_weight;
                ream_count_in_bundle += 1;

                if (total_bundle_weight > maxWightBundle || ream_count_in_bundle > maximum_bundle_limit) {
                    total_bundles = total_bundles + 1;
                    ream_per_bundle = ream_count_in_bundle - 1;

                    //  bundle weight calculation
                    bundleWeight = total_bundle_weight - ream.ream_weight;

                    total_bundle_weight = ream.ream_weight;
                    ream_count_in_bundle = 1;

                    //update hdr details
                    // let bWt = parseFloat(bundleWeight.toFixed(GlobalConfig.DecimalPointsBundleWeight))
                    let bWt = BundleWeightRounding(bundleWeight);
                    addBundleDetails(total_bundles, bWt, ream_per_bundle, false);
                    addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);

                }
                else {
                    addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                }

            });

            // lose bundle calculation
            let lbundle = 0;
            let lbundleWeight = 0;

            if (total_bundle_weight > 0 || ream_count_in_bundle > 0) {

                if (total_bundle_weight === maxWightBundle || ream_count_in_bundle === maximum_bundle_limit) {
                    total_bundles += 1;
                    bundleWeight = total_bundle_weight;
                    let l_bundle_number = total_bundles;
                    //let bWt = parseFloat(bundleWeight.toFixed(GlobalConfig.DecimalPointsBundleWeight))

                    let bWt = BundleWeightRounding(bundleWeight);

                    addBundleDetails(l_bundle_number, bWt, ream_count_in_bundle, false);
                    setlossReams(0);
                    setLReamWeight(0);
                }
                else {
                    lbundle = 1;
                    //lbundleWeight = parseFloat(total_bundle_weight.toFixed(GlobalConfig.DecimalPointsBundleWeight));

                    lbundleWeight = BundleWeightRounding(total_bundle_weight);

                    setlossReams(1);
                    setLReamWeight(lbundleWeight);

                    //update hdr details
                    let l_bundle_number = total_bundles + 1;
                    //let bWt = parseFloat(lbundleWeight.toFixed(GlobalConfig.DecimalPointsBundleWeight))

                    let bWt = BundleWeightRounding(lbundleWeight);

                    addBundleDetails(l_bundle_number, bWt, ream_count_in_bundle, true);
                }

            }
            else {
                setlossReams(0);
                setLReamWeight(0);
            }


            // bundle-weight     
            setReamWeight(BundleWeightRounding(bundleWeight));
            setTotalReams(total_bundles + lbundle);
            setNumberOfReams(total_bundles);
            setNumberOfSheets(totalReams);
            setRefreshCalculation(false);

            if (ream_per_bundle != 0) {
                if (sheeterNoOfSheets > ream_per_bundle) {
                    callError('info', `We cannot set ${sheeterNoOfSheets} per bundle because the maximum weight limit is ${maxWightBundle}.`, 'info');
                    setSheeterNoOfSheets(ream_per_bundle);
                }
            }



        }
        else {
            setTotalReams(0);
        }

    }, [sheeterNoOfSheets, numberofSheets, setSheeterNoOfSheets, refreshCalculation]);


    const callBundleCalCulation = () => {
        if (sheeterNoOfSheets > 0 && numberofSheets > 0) {

            setSheeterMsgOpen(false);

            let totalReams = checkedReams.length;
            let bundleWeight = 0;
            setBundleDetails([]);
            setBundleWiseReam([]);

            // calculate number of bundles
            let total_bundle_weight = 0;
            let total_bundles = 0;
            let ream_count_in_bundle = 0;
            let ream_per_bundle = 0;
            let maximum_bundle_limit = parseInt(sheeterNoOfSheets);

            checkedReams.forEach(ream => {

                total_bundle_weight += ream.ream_weight;
                ream_count_in_bundle += 1;

                if (total_bundle_weight > maxWightBundle || ream_count_in_bundle > maximum_bundle_limit) {
                    total_bundles = total_bundles + 1;
                    ream_per_bundle = ream_count_in_bundle - 1;

                    //  bundle weight calculation
                    bundleWeight = total_bundle_weight - ream.ream_weight;

                    total_bundle_weight = ream.ream_weight;
                    ream_count_in_bundle = 1;

                    //update hdr details
                    //let bWt = parseFloat(bundleWeight.toFixed(GlobalConfig.DecimalPointsBundleWeight))

                    let bWt = BundleWeightRounding(bundleWeight);

                    addBundleDetails(total_bundles, bWt, ream_per_bundle, false);
                    addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);

                }
                else {
                    addReamList(total_bundles + 1, ream.id_ream, ream.ream_code);
                }

            });

            // lose bundle calculation
            let lbundle = 0;
            let lbundleWeight = 0;

            if (total_bundle_weight > 0 || ream_count_in_bundle > 0) {

                if (total_bundle_weight === maxWightBundle || ream_count_in_bundle === maximum_bundle_limit) {
                    total_bundles += 1;
                    bundleWeight = total_bundle_weight;
                    let l_bundle_number = total_bundles;
                    //  let bWt = parseFloat(bundleWeight.toFixed(GlobalConfig.DecimalPointsBundleWeight))

                    let bWt = BundleWeightRounding(bundleWeight);

                    addBundleDetails(l_bundle_number, bWt, ream_count_in_bundle, false);
                    setlossReams(0);
                    setLReamWeight(0);
                }
                else {
                    lbundle = 1;
                    //lbundleWeight = parseFloat(total_bundle_weight.toFixed(GlobalConfig.DecimalPointsBundleWeight));

                    lbundleWeight = BundleWeightRounding(total_bundle_weight);

                    setlossReams(1);
                    setLReamWeight(lbundleWeight);

                    //update hdr details
                    let l_bundle_number = total_bundles + 1;
                    //let bWt = parseFloat(lbundleWeight.toFixed(GlobalConfig.DecimalPointsBundleWeight))

                    let bWt = BundleWeightRounding(lbundleWeight);

                    addBundleDetails(l_bundle_number, bWt, ream_count_in_bundle, true);
                }

            }
            else {
                setlossReams(0);
                setLReamWeight(0);
            }


            // bundle-weight     
            setReamWeight(BundleWeightRounding(bundleWeight));
            setTotalReams(total_bundles + lbundle);
            setNumberOfReams(total_bundles);
            setNumberOfSheets(totalReams);
            setRefreshCalculation(false);

            if (ream_per_bundle != 0) {
                if (sheeterNoOfSheets > ream_per_bundle) {
                    callError('info', `We cannot set ${sheeterNoOfSheets} per bundle because the maximum weight limit is ${maxWightBundle}.`, 'info');
                    setSheeterNoOfSheets(ream_per_bundle);
                }
            }



        }
        else {
            setTotalReams(0);
        }
    }






    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;

    // pallet list
    const handleSelectAllClickPallet = (event) => {
        if (event.target.checked) {
            const newSelectedRows = reamList.map((row) => row.id_bundle_val);
            setSelectedReamRows(newSelectedRows);
            return;
        }
        setSelectedReamRows([]);
    };

    const handleRowCheckboxClickPallet = (event, rowId) => {
        const selectedIndex = selectedReamRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedReamRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedReamRows.slice(1);
        } else if (selectedIndex === selectedReamRows.length - 1) {
            newSelectedRows = selectedReamRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedReamRows.slice(0, selectedIndex),
                ...selectedReamRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedReamRows(newSelectedRows);

    };

    const isSelectedReam = (rowId) => selectedReamRows.indexOf(rowId) !== -1;

    const [selectedChip, setSelectedChip] = useState('Combinations');


    const handleChipClick = (chipName) => {
        setSelectedChip(chipName);

        if (chipName === 'View Reel List') {
            setViewLineItemList(false);
            setviewPalletList(true);
            setviewReamProcess(false);
        }
        else if (chipName === 'View Sheeter Process') {
            setviewSheeterchildRollDetail(true);
            setviewPalletList(false);
        }
        else if (chipName === 'Line Item Wise Achieved Reels') {
            setViewLineItemList(true);
            setviewPalletList(false);
        }
        else if (chipName === 'View Summary') {
            // setviewSheeterchildRollDetail(true);
            setViewJob(true);
            setNewJob(false);
            setJobID(0);
        }


        // setShowFunction();
    };
    const iconStyle = {
        fontSize: '24px', // Ensure all icons have the same size
    };

    const selectedChipStyle = {
        borderColor: colors.greenAccent[200],
        borderWidth: '0.5px',
        borderStyle: 'solid',
        backgroundColor: colors.primary[700],
        // borderColor: '#2196F3',
        color: 'white'
    };
    const unselectedChipStyle = {

        borderColor: 'transparent',
        borderWidth: '1px',
        borderStyle: 'solid',
        backgroundColor: colors.primary[400],
        color: 'white',
    };


    const LoadSelectedLineItemList = () => {

        setSelectedChip('View Sheeter Process');
        const selectedReels = reelList.filter((reels) => selectedRows.includes(reels.id_ream));
        if (selectedReels.length > 0) {
            setSelectedReelList(selectedReels);
            setviewReamProcess(true);
            setviewPalletList(false);
            setSheeterNoOfSheets(sheeterNoOfSheets);
            callBundleCalCulation();

        }

    }
    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setShiftCodes(data);
                        setWinderShiftCode(data[0]);
                        setWinderShiftID(data[0].shiftid);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);

    const handleWinderShiftChange = (event, value) => {
        // setFilters((prevFilters) => ({
        //     ...prevFilters,
        //     cr_number: value,  // Update with selected cr_number values
        // }));

        setWinderShiftCode(value);
        setWinderShiftID(value.shiftid);
    }

    const handleCRNumberChange = (event, value) => {
        // If `value` is a single string:

        if (!value || value.length === 0) {
            // Reset to original reelList if value is null or empty
            setFilteredReelData(reelList);
            setcr_number(value);
        }
        else if (typeof value === 'string') {
            setFilteredReelData(reelList.filter((row) => row.cr_number === value));
            setcr_number(value);
        }
        // If `value` is an array:
        else if (Array.isArray(value)) {
            setFilteredReelData(reelList.filter((row) => value.includes(row.cr_number)));
            setcr_number(value);
        }
    };


    useEffect(() => {
        if (!isOperatorDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setOperator(data);
                        setSelectedOperator(data[0]);
                        setSelectedOperatorName(data[0].operator_code);
                        setWinderOperators(data[0].operator_code);
                        setOperatorID(data[0].id);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isOperatorDataLoaded]);


    const handleOperatorChange = (event, value) => {
        setSelectedOperator(value);
        setSelectedOperatorName(value.operator_code);
        setWinderOperators(value.operator_code);
        setOperatorID(value.id);
    }


    const viewQRCode = async () => {
        const palletDetails1 = approvedPalletNumber.filter((ream) => selectedReamRows.includes(ream.id));
        const palletDetails = reamList.filter((ream) => selectedReamRows.includes(ream.id_bundle_val));
        setSelectedReamDetails(palletDetails);
        setSelectedReamDetailsQR(palletDetails1);
        setViewReamQRCode(true);
    };

    const handlecallEditJob = (jobID) => {
        if (!hasPermission(userPermissions, "Bundle Punching", "View")) {
            alert("Access denied. You don’t have permission to view this page.");
            return; // Exit the function if permission is not granted
        }
        setJobID(jobID);

        setviewReamProcess(true);
        setviewPalletList(false);

        setViewJob(false);
        setNewJob(true);

        setSelectedChip('View Sheeter Process');

        setViewLineItemList(false);
    }

    // get job header details
    const [jobHDRDetails, setJobHDRDetails] = useState([]);
    const [updateshiftCode, setUpdateShiftCode] = useState('');
    const [updateOperator, setUpdateOperator] = useState('');
    const [shiftCodeUpdate, setShiftCodeUpdate] = useState(false);
    const [operatorUpdate, setOperatorUpdate] = useState(false);

    useEffect(() => {
        if (jobID > 0) {
            setViewLineItemList(false);
            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_job_number: jobID

            };
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_BUNDLE_CONVERTION_GET_JOD_HDR_DETAIL_USING_JOB_ID, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        const [firstJob] = data;
                        setJobHDRDetails(data);

                        setSheeterNoOfSheets(data[0].no_of_sheets);
                        //calculatePallets(data[0].no_of_sheets);

                        setUpdateShiftCode(firstJob.shift_code);
                        setShiftCodeUpdate(false);
                        setUpdateOperator(firstJob.s_operator);
                        setOperatorUpdate(false);

                        setShiftDate(dayjs(firstJob.shift_date));
                        setSelectedGrade(firstJob.grade ? firstJob.grade : '');
                        setLocationRef(firstJob.location);

                    } else {
                        // No data found
                        setJobHDRDetails([]);
                        callError('info', 'No data found, Kindly adjust data range.', 'info');
                    }
                })
                .catch(error => { callError('error', error.message, 'Error'); });
        }

    }, [jobID]);




    useEffect(() => {
        if (jobID > 0) {

            setViewLineItemList(false);

            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_job_number: jobID

            };


            callApi(API_ENDPOINTS.PROD_MANAGEMENT_REAM_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_REAM_LIST_USING_JOB_ID, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {

                        setSelectedReelList(data);
                        totalSheetsAndReam(data);
                        setRefreshCalculation(true);
                        const parameter = {
                            p_companyid: localStorage.getItem('companyid'),
                            p_plantid: 1,
                            p_indent_no: data[0].indent_no,
                            p_lineno: data[0].line_no

                        };

                        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SELECTED_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, parameter)
                            .then(LineItemData => {
                                if (LineItemData && LineItemData.length > 0) {
                                    setSelectedLineItemDetail(LineItemData);
                                }
                            })
                            .catch(error => { callError('error', error.message, 'Error'); });



                    } else {
                        // No data found
                        setSelectedReelList([]);
                        callError('info', 'No data found, Kindly adjust data range.', 'info');
                    }
                })
                .catch(error => { callError('error', error.message, 'Error'); });
        }

    }, [jobID]);

    const LoadJobRelatedDetails = () => {
        if (jobID > 0) {

            setViewLineItemList(false);

            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_job_number: jobID

            };


            callApi(API_ENDPOINTS.PROD_MANAGEMENT_REAM_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_REAM_LIST_USING_JOB_ID, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {

                        setSelectedReelList(data);
                        totalSheetsAndReam(data);
                        setRefreshCalculation(true);
                        const parameter = {
                            p_companyid: localStorage.getItem('companyid'),
                            p_plantid: 1,
                            p_indent_no: data[0].indent_no,
                            p_lineno: data[0].line_no

                        };

                        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SELECTED_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, parameter)
                            .then(LineItemData => {
                                if (LineItemData && LineItemData.length > 0) {
                                    setSelectedLineItemDetail(LineItemData);

                                }

                            })
                            .catch(error => { callError('error', error.message, 'Error'); });



                    } else {
                        // No data found
                        setSelectedReelList([]);
                        callError('info', 'No data found, Kindly adjust data range.', 'info');
                    }
                })
                .catch(error => { callError('error', error.message, 'Error'); });
        }
    }


    // reel list
    useEffect(() => {
        if (jobID > 0) {
            setViewLineItemList(false);
            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_bundle_number: '',
                p_mode: 1,
                p_pallet_id: jobID
            };

            setBundleListLoading(true);
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_BUNDLE_DETAIL_NEW, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setReamList(data);
                        setViewReamQRCode(true);
                        setBundleListLoading(false);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [jobID]);

    const LoadProducedBundleList = () => {
        if (jobID > 0) {
            setViewLineItemList(false);
            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_bundle_number: '',
                p_mode: 1,
                p_pallet_id: jobID
            };
            setBundleListLoading(true);
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_BUNDLE_DETAIL_NEW, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setReamList(data);
                        setViewReamQRCode(true);
                        setBundleListLoading(false);
                        // const result = data.reduce(
                        //     (acc, item) => {
                        //         if (!item.bundle_status) {
                        //             acc.fullbundle++;
                        //             acc.fullbundleReams += item.no_of_reams;
                        //         } else {
                        //             acc.loosebundle++;
                        //             acc.loosebundleReams += item.no_of_reams;
                        //         }
                        //         return acc;
                        //     },
                        //     { loosebundle: 0, fullbundle: 0, loosebundleReams: 0, fullbundleReams: 0 }
                        // );

                        // setNumberOfReams(result.fullbundle);
                        // setlossReams(result.loosebundle);
                        // setNumberOfSheets(result.fullbundleReams+ result.loosebundleReams);                        

                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }

    useEffect(() => {
        if (shiftCodeUpdate) return;

        const params = { p_companyid: localStorage.getItem('companyid') };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setShiftCodes(data);
                    const selectedShift = data.find(shift => shift.shiftid === updateshiftCode);
                    if (selectedShift) {
                        setWinderShiftCode(selectedShift);
                        setWinderShiftID(selectedShift.shiftid);
                    }
                }
                setShiftCodeUpdate(true);
            })
            .catch(error => alert(error.message));
    }, [updateshiftCode, shiftCodeUpdate]);

    useEffect(() => {
        if (operatorUpdate) return;

        const params = { p_companyid: localStorage.getItem('companyid'), p_plantid: 1 };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setOperator(data);
                    const selectedOperator = data.find(operator => operator.operator_code === updateOperator);
                    if (selectedOperator) {
                        setSelectedOperator(selectedOperator);
                        setSelectedOperatorName(selectedOperator.operator_code);
                        setWinderOperators(selectedOperator.operator_code);
                    }
                }
                setOperatorUpdate(true);
            })
            .catch(error => alert(error.message));
    }, [updateOperator, operatorUpdate]);


    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };

    const convertInputDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${month}/${day}/${year}`;
    };

    const convertDataDate = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return `${month}/${day}/${year}`;
    };

    const summaryData = summaryList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied

                if (key === 'from_date' || key === 'to_date') {
                    // Convert row date to Date object
                    const rowDate = new Date(convertDataDate(row.date));
                    const fromDate = filters.from_date ? new Date(convertInputDate(filters.from_date)) : null;
                    const toDate = filters.to_date ? new Date(convertInputDate(filters.to_date)) : null;

                    // Check if row date is within the range
                    if (fromDate && toDate) {
                        return rowDate >= fromDate && rowDate <= toDate;
                    } else if (fromDate) {
                        return rowDate >= fromDate;
                    } else if (toDate) {
                        return rowDate <= toDate;
                    }
                    return true;
                }

                // Default string comparison for other filters
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const applyFilter = () => {

        const convertInputDate = (dateString) => {
            const [year, month, day] = dateString.split('-');
            return `${month}/${day}/${year}`;
        };

        // Convert 'dd/mm/yyyy' to 'mm/dd/yyyy'
        const convertDataDate = (dateString) => {
            const [day, month, year] = dateString.split('/');
            return `${month}/${day}/${year}`;
        };

        const fromDate = new Date(convertInputDate(filters.from_date));
        const toDate = new Date(convertInputDate(filters.to_date));

        const summaryData = summaryList.filter(item => {
            const itemDate = new Date(convertDataDate(item.date));
            return itemDate >= fromDate && itemDate <= toDate;
        });

        console.log(summaryData); // Use `filteredData` as needed
        //setFilteredData(filteredData);
    };

    // sorting process
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortColumn, setSortColumn] = useState('date'); // Default sort by 'date'


    const handleSort = (column) => {
        const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(newDirection);
        setSortColumn(column);
    };

    const sortedData = useMemo(() => {
        return [...summaryData].sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        });
    }, [summaryData, sortColumn, sortDirection]);

    const handleSubMenuButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        // setSelectedButtonName(buttonName);

        // handlecallProcess(buttonName);
        setSelectedChip(buttonName);

        if (buttonName === 'View Reel List') {
            setViewLineItemList(false);
            setviewPalletList(true);
            setviewReamProcess(false);
            setViewReamQRCode(false); //new added for hide produced ream list

            if (disableSaveBtn) {
                if (selectedOrderItems) {
                    handleCallEdit(selectedOrderItems);
                    setSelectedRows([]);
                    setDisableSaveBtn(false);
                    setNumberOfReams(0);
                    setFilters({
                        cr_number: '',
                    });

                    setShiftDate(dayjs());
                }
            }
        }
        else if (buttonName === 'View Sheeter Process') {
            setviewSheeterchildRollDetail(true);
            setviewPalletList(false);
        }
        else if (buttonName === 'Line Item Wise Achieved Reels') {
            setViewLineItemList(true);
            setviewPalletList(false);
        }
        else if (buttonName === 'View Summary') {
            // setviewSheeterchildRollDetail(true);
            setViewJob(true);
            setNewJob(false);
            setJobID(0);
        }
    };

    const [viewSelectedReams, setViewSeletedReams] = useState(false);




    // insert bundle details:

    const InsertBundleDetails = () => {
        if (totalReams === 0 && sheeterNoOfSheets === 0) {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('No Bundle Available to create.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);

            return;
        }
        if (reamWeignt === 0) {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('Please check the Bundle Weight is not calculated.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }

        if (winderShiftID === 0) {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('Please set Shift Code.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }

        if (operatorID === 0) {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('Please set Operator.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }

        if (locationRef === '') {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('Please set Location Code.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }
        const userID = localStorage.getItem('userID');
        if (!userID || userID === '0') {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('User session expired. Please login again.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }
        if (selectedGrade.length === 0) {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('Please select the grade.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }

        const parameter = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_ream_detail: bundleWiseReam,
            p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
            p_shift_id: winderShiftID,
            p_user_id: operatorID,
            p_bundle_weight: reamWeignt,
            p_l_bundle_weight: lReamWeignt,
            p_reams_bundle: sheeterNoOfSheets,
            p_total_bundle: totalReams,
            p_l_bundle: lossReams,
            p_max_bundle_weight: maxWightBundle,
            p_user: localStorage.getItem('userID'),
            p_bundle_detail: bundleDetails,
            // 'location chnaged label to remarks for Lemit Papers'
            p_location_ref: locationRef,
            p_grade: selectedGrade
        }

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_CREATE_BUNDLE_USING_MULTIPLE_REAM, 'POST', { 'Content-Type': 'application/json' }, parameter)
            .then(data => {
                if (data && data.length > 0) {
                    setApprovedPalletNumber(data);

                    setViewReamsList(true);
                    setDisableSaveBtn(true);
                    setDisbleSheetValue(true);
                    setPalletStatus('Completed')

                    let id_ream_hdr = data[0].id_hdr;


                    const reamFilter = {
                        p_companyid: localStorage.getItem('companyid'),
                        p_bundle_number: '',
                        p_mode: 1,
                        p_pallet_id: id_ream_hdr
                    };
                    setBundleListLoading(true);
                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_BUNDLE_DETAIL_NEW, 'POST', { 'Content-Type': 'application/json' }, reamFilter)
                        .then(reamdata => {
                            if (reamdata && reamdata.length > 0) {
                                setReamList(reamdata);
                                setViewReamQRCode(true);
                                setBundleWiseReam([]);
                                setBundleDetails([]);
                                setBundleListLoading(false);

                                callError('info', 'Bundle number created.', 'info');

                                alert("Bundle Number Created Successfully.")
                            }
                        })
                        .catch(error => {
                            alert(error.message);
                        });
                }
            })
            .catch(error => {
                alert(error.message);
            });
    };


    const handleIndentNoChange = (event, value) => {
        if (value !== undefined && value != null) {
            setFilterIndentno(value);
            LoadOrderItemDetailsFilterByCONumber(value.indent_no);
        }
        else {
            setFilterIndentno('');
            LoadOrderItemDetails(FromDate, ToDate);
        }
    }
    const AlertMessage = (severity, message, title, open) => {
        setSheeterSeverityvalue(severity);
        setSheeterMessageValue(message);
        setSheeterAlertTitleValue(title);
        setSheeterMsgOpen(open);
    };

    const DeleteSelectedBundleProductionJobDetails = () => {
        if (!hasPermission(userPermissions, "Bundle Punching", "Delete")) {
            alert("Access denied. You don’t have permission to delete the bundles.");
            return; // Exit the function if permission is not granted
        }
        let printselectedReamDetails = reamList;
        printselectedReamDetails = reamList.filter((ream) => selectedReamRows.includes(ream.id_bundle_val));

        if (jobID === 0) {
            AlertMessage('warning', 'Please select the Job Details to delete.', 'Warning', true);
            return;
        }

        if (printselectedReamDetails.length === 0) {
            AlertMessage('warning', 'Please select at least one bundle code to delete', 'Warning', true);
            return;
        }

        if (reamList.length === printselectedReamDetails.length) {
            AlertMessage('warning', 'Cannot delete all bundles in a Job. Please delete the entire job.', 'Warning', true);
            return;
        }

        const confirmDelete = window.confirm(`Are you sure you want to delete the selected bundles in this job details?`);

        if (confirmDelete) {
            setSheeterMsgOpen(false);

            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plant_id: 1,
                p_selected_reams: printselectedReamDetails,
            };

            // create reams                   
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_DeleteSelectedBundlesInReamJob, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        if (data === 'Selected Bundles are deleted successfully.') {

                            LoadJobList();
                            LoadProducedBundleList();



                            AlertMessage('success', data, 'Success', true);
                        }
                        else {
                            AlertMessage('warning', data, 'Warning', true);
                        }
                    }
                    else {
                        AlertMessage('error', 'Unable to delete the Selected Bundles In Job.', 'Error', true);
                    }
                })
                .catch(error => {
                    AlertMessage('error', error.message, 'Error', true);
                });
        }
    }


    const DeleteBundleProductionJobDetails = () => {
        if (!hasPermission(userPermissions, "Bundle Punching", "Delete")) {
            alert("Access denied. You don’t have permission to delete this job.");
            return; // Exit the function if permission is not granted
        }

        const confirmDelete = window.confirm(`Are you sure you want to delete the entire job ${jobID}?`);

        if (confirmDelete) {
            if (jobID === 0) {
                AlertMessage('warning', 'Please select the Job Details to delete.', 'Warning', true);
                return;
            }

            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_pallet_id: jobID
            };

            // create reams                   
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_DeleteBundleJobDetails, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        if (data[0].status === 'success') {
                            LoadJobList();
                            setviewReamProcess(false);
                            setviewPalletList(true);
                            setViewLineItemList(true);

                            setSelectedChip('');
                            setViewJob(true);
                            setNewJob(false);

                            alert('Bundle Job Deleted successfully.')
                        }
                        else {
                            AlertMessage('warning', data[0].message, 'Warning', true);
                        }
                    }
                    else {
                        AlertMessage('error', 'Unable to delete the Bundle Job.', 'Error', true);
                    }
                })
                .catch(error => {
                    AlertMessage('error', error.message, 'Error', true);
                });
        }
    }

    const handleFromShiftDateChange = (date) => {
        setFromShiftDate(dayjs(date));
    };

    const handleToShiftDateChange = (date) => {
        setToShiftDate(dayjs(date));
    };

    // filter oprations 
    const columns = ['job_number', 'shift_code', 'shift_date', 'indent_no', 'cr_number', 's_operator', 'bundle_count'];
    const autoCompleteColumns = ['job_number', 'shift_code', 'shift_date', 'indent_no', 'cr_number', 's_operator', 'bundle_count'];

    const handleFilterChangeTable = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const uniqueValues = {
        job_number: [...new Set(summaryList.map(row => row.job_number))],
        shift_code: [...new Set(summaryList.map(row => row.shift_code))],
        shift_date: [...new Set(summaryList.map(row => row.shift_date))],
        indent_no: [...new Set(summaryList.map(row => row.indent_no))],
        cr_number: [...new Set(summaryList.map(row => row.cr_number))],
        s_operator: [...new Set(summaryList.map(row => row.s_operator))],
        bundle_count: [...new Set(summaryList.map(row => row.bundle_count))],
        status: [...new Set(summaryList.map(row => row.status))],
    };
    const handleUpdate = async () => {

        try {
            const para = {
                p_companyid: localStorage.getItem("companyid"),
                p_shift_id: winderShiftID,
                p_shift_date: dayjs(winderShiftDate).format("DD-MMM-YYYY"),
                p_operator_id: operatorID,
                p_grade: selectedGrade,
                p_user: localStorage.getItem("userID"),
                p_location: locationRef,
                p_job_number: jobID,
                p_plantid: 1
            };

            const response = await callApi(
                API_ENDPOINTS.PROD_MANAGEMENT_UPDATE_BUNDLE_PUNCHING_JOB_NUMBER,
                "POST",
                { "Content-Type": "application/json" },
                para
            );

            if (response && response.length > 0) {
                setSheeterSeverityvalue("success");
                setSheeterMessageValue("Bundle updated successfully");
                setSheeterAlertTitleValue("Success");
                setSheeterMsgOpen(true);
            } else {
                throw new Error("Update failed");
            }
        } catch (error) {
            setSheeterSeverityvalue("error");
            setSheeterMessageValue(error.message);
            setSheeterAlertTitleValue("Error");
            setSheeterMsgOpen(true);
        }
    };


    // Calculate the number of pages
    const pageCount = Math.ceil(summaryList.length / recordsPerPage);

    // Get the records for the current page
    const currentRecords = sortedData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );





    return (
        <Box>



            {viewJob && (
                <>
                    <Divider />

                    <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                        <Toolbar>
                            {/* First Menu */}
                            <Button
                                color="secondary"
                                onClick={handleMenuClickFirst}
                                endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                            >
                                {selectedOptionFirst}
                            </Button>
                            <Menu
                                anchorEl={anchorElFirst}
                                open={openFirst}
                                onClose={handleMenuCloseFirst}

                            >
                                <MenuItem onClick={() => handleMenuItemClickFirst('All Bundle Punching')}>Bundle Puching Summary</MenuItem>
                            </Menu>
                            {/* <Button
    size="small"
    variant="contained"
    onClick={handleOpenWIPListModal}
    color="secondary"
    sx={{ textTransform: 'none' }}
  >
    View WIP Bundle List
  </Button> */}
                            {/* Adding margin-left: auto to push the button to the right */}
                            <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>

                            {/* Second Menu */}
                            <IconButton
                                size="small"
                                // edge="start"
                                // color="inherit"
                                aria-label="menu"
                                sx={{ ml: 2 }}
                                onClick={handleMenuClickSecond}
                            >
                                <MoreVertIcon sx={{ fontSize: "18px" }} />
                            </IconButton>
                            <Menu
                                anchorEl={anchorElSecond}
                                open={openSecond}
                                onClose={handleMenuCloseSecond}
                            >
                                <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                                    <ListItemIcon>
                                        <ImportExportIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Import Child rolls" />
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                                    <ListItemIcon>
                                        <FileDownloadIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Child rolls" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                    <ListItemIcon>
                                        <ViewColumnIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Current View" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                    <ListItemIcon>
                                        <ListAltIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Preference " />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                    <ListItemIcon>
                                        <RefreshIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Refresh List" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                    <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                        Reset Columns Width
                                    </Button>
                                </MenuItem>
                            </Menu>



                            <div>
                                <IconButton onClick={handleBackWinderMachineEntry} >
                                    <Close sx={{ fontSize: "18px", color: "#2196F3" }} style={{ color: "#2196F3" }} />
                                </IconButton>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <Grid container padding="5px 0px 5px 5px" alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-end" }} >
                        <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px">
                            <FormControl fullWidth size="small">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        style={{ marginLeft: '10px' }}
                                        id="FromDate"
                                        value={dayjs(FromShiftDate)}
                                        onChange={(date) => handleFromShiftDateChange(date)}

                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                variant: 'standard', // Removes the filled/outlined border
                                                InputProps: {
                                                    disableUnderline: true, // Remove underline from 'standard' variant
                                                },
                                                sx: {
                                                    backgroundColor: 'transparent',
                                                    padding: 0,
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '18px', // 👈 smaller icon size
                                                    },
                                                    '& .MuiInputBase-root': {
                                                        paddingRight: '6px', // optional: reduce padding around icon
                                                    },
                                                },
                                            }
                                        }}
                                        renderInput={(props) => <TextField {...props} />}
                                        autoFocus
                                        format="DD-MMM-YYYY"
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item mt="5px" ml="10px" mr="10px">
                            <Typography fontWeight="bold">-</Typography>
                        </Grid>


                        <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px" mr="10px">
                            <FormControl fullWidth size="small" >
                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                    <DatePicker
                                        id="ToDate"
                                        value={dayjs(ToShiftDate)}
                                        format="DD-MMM-YYYY"
                                        onChange={(date) => handleToShiftDateChange(date)}

                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                variant: 'standard', // Removes the filled/outlined border
                                                InputProps: {
                                                    disableUnderline: true, // Remove underline from 'standard' variant
                                                },
                                                sx: {
                                                    backgroundColor: 'transparent',
                                                    padding: 0,
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '18px', // 👈 smaller icon size
                                                    },
                                                    '& .MuiInputBase-root': {
                                                        paddingRight: '6px', // optional: reduce padding around icon
                                                    },
                                                },
                                            }
                                        }}
                                        renderInput={(props) => <TextField {...props} />}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>


                    </Grid>
                    <Divider sx={{ marginTop: "5px" }} />

                    <ResponsiveBox colors={colors} customMaxHeight={{
                        xs: '72vh', // Extra small devices (phones)
                        sm: '72vh', // Small devices (tablets)
                        md: '74vh', // Medium devices (small laptops)
                        lg: '77vh', // Large devices (desktops)
                        xl: '86vh', // Extra large devices (large desktops)
                    }}>

                        <CustomTableContainer colors={colors} >
                            <TableContainer >
                                {loading ? (
                                    <SkeletonTableLoader rows={5} columns={11} />
                                ) : (
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                            <TableRow>
                                                <TableCell sx={{ minWidth: 100, whiteSpace: "nowrap" }} onClick={() => handleSort('job_number')}>
                                                    JOB NUMBER {sortColumn === 'job_number' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('shift_code')}>
                                                    SHIFT {sortColumn === 'shift_code' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell sx={{ minWidth: 100, whiteSpace: "nowrap" }} onClick={() => handleSort('shift_date')}>
                                                    SHIFT DATE {sortColumn === 'shift_date' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell sx={{ minWidth: 100, whiteSpace: "nowrap" }} onClick={() => handleSort('indent_no')}>
                                                    CO NUMBER  {sortColumn === 'indent_no' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                <TableCell onClick={() => handleSort('cr_number')}>
                                                    CHILD REEL NUMBER  {sortColumn === 'cr_number' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>



                                                <TableCell onClick={() => handleSort('s_operator')}>
                                                    SUPERVISOR {sortColumn === 's_operator' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                <TableCell onClick={() => handleSort('pallet_count')}>
                                                    TOTAL BUNDLES {sortColumn === 'pallet_count' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                {/* <TableCell onClick={() => handleSort('status')}>
                                                    STATUS {sortColumn === 'status' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell> */}



                                                {/* <TableCell>
                                                    <IconButton onClick={handleOpen}>
                                                        <Searchicon style={{ fontSize: "16px" }} />
                                                    </IconButton>
                                                    <Modal
                                                        open={open}
                                                        onClose={handleClose}
                                                        aria-labelledby="modal-modal-title"
                                                        aria-describedby="modal-modal-description"
                                                    >
                                                        <Box sx={{ position: 'absolute', top: '38.2%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: colors.primary[400], boxShadow: 29, p: 4, minWidth: 300 }}>



                                                            <TextField
                                                                label="JOB Number"
                                                                name="job_number"
                                                                value={filters.job_number}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                size="small"
                                                                margin="normal"
                                                            />

                                                            <TextField
                                                                label="CO Number"
                                                                name="indent_no"
                                                                value={filters.indent_no}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                margin="normal"
                                                            />

                                                            <TextField
                                                                label="Child Reel Number"
                                                                name="cr_number"
                                                                value={filters.cr_number}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                            />



                                                            <Button variant="contained" color="secondary" onClick={() => { applyFilter(); handleClose(); }} style={{ marginTop: 10 }}>
                                                                Apply Filter
                                                            </Button>
                                                        </Box>
                                                    </Modal>
                                                </TableCell> */}
                                            </TableRow>
                                            <TableFilterRow
                                                columns={columns}
                                                filters={filters}
                                                handleFilterChange={handleFilterChangeTable}
                                                uniqueValues={uniqueValues}
                                                autoCompleteColumns={autoCompleteColumns}
                                            />
                                        </TableHead>
                                        <TableBody>
                                            {currentRecords.map((row, index) => (
                                                <TableRow key={row.id} sx={{ backgroundColor: index % 2 === 0 ? theme.palette.background.default : alpha(theme.palette.action.hover, 0.04), }}>
                                                    <TableCell> <span
                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                        onClick={() => handlecallEditJob(row.job_number)}
                                                    >
                                                        JOB# {row.job_number}
                                                    </span></TableCell>
                                                    <TableCell>{row.shift_code}</TableCell>
                                                    <TableCell>{row.shift_date}</TableCell>
                                                    <TableCell>{row.indent_no}</TableCell>
                                                    <TableCell>{row.cr_number}</TableCell>
                                                    <TableCell>{row.s_operator}</TableCell>

                                                    <TableCell sx={{ textAlign: 'right' }}>{`${row.bundle_count} `}</TableCell>
                                                    {/* <TableCell>{row.status}</TableCell> */}

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                )}

                                <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                                    <Pagination
                                        count={pageCount}
                                        page={currentPage}
                                        onChange={(event, value) => setCurrentPage(value)}

                                    />
                                </Box>
                            </TableContainer>
                        </CustomTableContainer>
                    </ResponsiveBox>

                </>
            )}


            {newJob && (



                <>
                    <Header title={t('prod_menu.bundlepunching')} subtitle="" callback={callback} />
                    <Dialog
                        open={open}
                        onClose={closepopup}
                        fullWidth
                        maxWidth="xs"

                    >
                        <DialogContent sx={{ backgroundColor: theme.palette.background.default }}>
                            <QualityCheckRejectProcee rejectReelType={'REAM'} rejectReason={rejectReason} setRejectReason={setRejectReason} selectedReason={selectedReason} setSelectedReason={setSelectedReason} rejectProductType={rejectProductType} setRejectProductType={setRejectProductType} rejectStatus={rejectStatus} setRejectStatus={setRejectStatus} rejectReasonID={rejectReasonID} setRejectReasonID={setRejectReasonID} rejectRemarks={rejectRemarks} setRejectRemarks={setRejectRemarks} enableReject={enableReject} setEnableReject={setEnableReject} />
                        </DialogContent>
                        <DialogActions sx={{ backgroundColor: theme.palette.background.default }}>
                            <Button onClick={closepopup} variant="contained">
                                Update
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Divider />


                    <Grid container display="flex-start" padding={0.5}>
                        {viewPalletList && (
                            <>
                                <Grid item md={0} ml="1px" mr="1px">
                                    <Tooltip title="Back to Line item wise achieved reams ">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleSubMenuButtonClick('Line Item Wise Achieved Reels')}  >
                                                <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'Line Item Wise Achieved Reels' ? "yellow" : "#009688" }} />
                                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Line Item Wise Achieved Reams</Typography>
                                            </IconButton>
                                            {/* <span style={{ fontSize: 12 }}>Edit</span> */}
                                        </div>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                <Grid item md={0} ml="1px" mr="1px">
                                    <Tooltip title="View available ream list for production">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleSubMenuButtonClick('View Reel List')} >
                                                <CheckCircleOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'View Reel List' ? "yellow" : "#009688" }} />
                                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Ream List</Typography>
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                            </>
                        )}


                        {viewReamProcess && (
                            <>
                                {jobID === 0 && (
                                    <>
                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Back to View ream list">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Reel List')} >
                                                        <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'View Reel List' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Ream List</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Convert reams to bundle process">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Sheeter Process')} >
                                                        <ArticleIcon style={{ fontSize: "18px", color: selectedButton === 'View Sheeter Process' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Sheeter Process</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

                                    </>
                                )}
                                {jobID > 0 && (
                                    <>

                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Back to Summary list">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Summary')} >
                                                        <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'View Summary' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Summary</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />


                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Convert reams to bundle process">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Sheeter Process')} >
                                                        <ArticleIcon style={{ fontSize: "18px", color: selectedButton === 'View Sheeter Process' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Bundle Punching Process</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                    </>
                                )}
                            </>
                        )}
                    </Grid>

                    {viewLineItemList === false && (
                        <Divider />
                    )}


                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={sheeterMsgOpen} setParentRollMsgOpen={setSheeterMsgOpen} parentRollSeverityvalue={sheeterSeverityvalue}
                        setParentRollSeverityvalue={setSheeterSeverityvalue} parentRollAlertTitleValue={sheeterAlertTitleValue}
                        setParentRollAlertTitleValue={setSheeterAlertTitleValue} parentRollMessageValue={sheeterMessageValue} setParentRollMessageValue={setSheeterMessageValue} />


                    <Box
                        sx={{
                            // backgroundColor: colors.primary[700],
                            padding: "10px",
                            borderRadius: "10px",
                            // marginTop: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '76vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>
                        <>
                            {(viewPalletList === false && viewReamProcess === false) && (
                                <>
                                    <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >
                                        <Grid container padding="0px 0px 1px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={1.6} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6"> {t('prod_paper_machine.filter_by')} </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={11} md={3.8} lg={1.75} xl={1.75}>
                                                <FormControl fullWidth size="small">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            style={{ marginLeft: '10px' }}
                                                            id="FromDate"
                                                            value={dayjs(FromDate)}
                                                            onChange={(date) => handleDateChange2(date)}
                                                            slotProps={{ textField: { size: 'small', } }}
                                                            renderInput={(props) => <TextField {...props} />}
                                                            autoFocus
                                                            format="DD-MMM-YYYY" // Use the appropriate format string
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={3.8} lg={1.75} xl={1.75}>
                                                <FormControl fullWidth size="small" >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                        <DatePicker
                                                            id="ToDate"
                                                            value={dayjs(ToDate)}
                                                            format="DD-MMM-YYYY"
                                                            onChange={(date) => handleDateChange1(date)}
                                                            slotProps={{ textField: { size: 'small', } }}
                                                            renderInput={(props) => <TextField {...props} />}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={1.6} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6">CO Number</Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                                                <Autocomplete
                                                    fullWidth
                                                    value={filterIndentno}
                                                    onChange={handleIndentNoChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={indentNoList}
                                                    getOptionLabel={(option) => (option?.indent_no ? `${option.indent_no}` : '')} // Safely handle undefined
                                                    renderInput={(params) =>
                                                        <TextField required
                                                            {...params} variant="outlined" placeholder="Enter CO Number" />}
                                                />
                                            </Grid>




                                        </Grid>
                                    </Grid>


                                    <Grid container padding="20px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>
                                </>
                            )}

                            {viewLineItemList && (
                                <>
                                    <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <ResponsiveBox customMaxHeight={{
                                                xs: '72vh', // Extra small devices (phones)
                                                sm: '72vh', // Small devices (tablets)
                                                md: '60vh', // Medium devices (small laptops)
                                                lg: '64vh', // Large devices (desktops)
                                                xl: '73vh', // Extra large devices (large desktops)
                                            }}>


                                                <CustomTableContainer colors={colors} >

                                                    <TableContainer >
                                                        {loadingOrderItemDet ? (
                                                            <SkeletonTableLoader rows={5} columns={11} />
                                                        ) : (

                                                            <Table size="small">
                                                                <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                                                    <TableRow>
                                                                        <TableCell sx={{ textAlign: "center" }}>CO DATE</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>CO NUMBER</TableCell>
                                                                        {/* <TableCell sx={{ textAlign: "center" }}>CUSTOMER NAME</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>SUPPLIER NAME</TableCell> */}
                                                                        <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>WIDTH</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>LENGTH</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>PRODUCED REAMS</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>ACH.QTY</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>PRODUCED QTY</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>TOTAL BUNDLE</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>REAM WEIGHT</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>NO.OF.SHEETS IN REAM</TableCell>
                                                                        {/* <TableCell sx={{ textAlign: "center" }}>LINE NUMBER</TableCell> */}
                                                                        <TableCell>Action</TableCell>
                                                                        <TableCell>
                                                                            <IconButton >
                                                                                {/* onClick={handleOpen} */}
                                                                                <Searchicon onClick={handleOpen} style={{ fontSize: "16px" }} />
                                                                            </IconButton>
                                                                            <Modal
                                                                                open={open}
                                                                                onClose={handleClose}
                                                                                aria-labelledby="modal-modal-title"
                                                                                aria-describedby="modal-modal-description"
                                                                            >
                                                                                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                                    <TextField
                                                                                        label="CO NUMBER"
                                                                                        name="indent_no"
                                                                                        size="small"
                                                                                        color="secondary"
                                                                                        value={filters.indent_no}
                                                                                        onChange={handleFilterChange}
                                                                                        variant="outlined"
                                                                                        fullWidth
                                                                                        margin="normal"
                                                                                    />

                                                                                    <TextField
                                                                                        label="QUALITY"
                                                                                        name="item_code"
                                                                                        size="small"
                                                                                        color="secondary"
                                                                                        value={filters.item_code}
                                                                                        onChange={handleFilterChange}
                                                                                        variant="outlined"
                                                                                        fullWidth
                                                                                        margin="normal"
                                                                                    />

                                                                                    <Button variant="contained" color="secondary" style={{ marginTop: 10 }}>

                                                                                        Apply Filter
                                                                                    </Button>
                                                                                </Box>
                                                                            </Modal>
                                                                        </TableCell>
                                                                    </TableRow>

                                                                </TableHead>
                                                                <TableBody>
                                                                    {filteredData.map((row) => (
                                                                        <>
                                                                            <React.Fragment key={row.indent_no}>
                                                                                <TableRow key={row.id}>

                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.indent_date}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "left", fontWeight: "bold" }}>
                                                                                        <span
                                                                                            style={{ color: '#039be5', textDecoration: 'underline', cursor: 'pointer' }}
                                                                                            onClick={() => handleCallEdit(row)}
                                                                                        >
                                                                                            {row.indent_no}
                                                                                        </span>
                                                                                    </TableCell>
                                                                                    {/* <TableCell sx={{ textAlign: "left" }}>{row.customer_name}</TableCell>
                                                                    <TableCell sx={{ textAlign: "left" }}>{row.supplier_name}</TableCell> */}
                                                                                    <TableCell sx={{ textAlign: "left" }}>{row.item_code}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.d_width}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.d_length}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.reel_count}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.total_qty}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.plannedqty}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.bundle_count}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.ream_weight}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.no_of_sheets}</TableCell>
                                                                                    {/* <TableCell sx={{ textAlign: "center" }}>{row.line_no}</TableCell> */}

                                                                                    <TableCell>
                                                                                        <Tooltip title="View child roll wise production">
                                                                                            <IconButton onClick={() => handleExpandRow(row)}>
                                                                                                {expandedRow === row.indent_no ? <ExpandLess style={{ color: 'teal', fontSize: "16px", fontWeight: "bold" }} /> : <ExpandMore style={{ color: 'teal', fontSize: "16px", fontWeight: "bold" }} />}
                                                                                            </IconButton>
                                                                                        </Tooltip>
                                                                                    </TableCell>
                                                                                </TableRow>

                                                                                {/* Expanded Row */}
                                                                                {expandedRow === row.indent_no && (
                                                                                    <TableRow>
                                                                                        <TableCell colSpan={8}>
                                                                                            <Collapse in={expandedRow === row.indent_no} timeout="auto" unmountOnExit>
                                                                                                {/* <Box margin={1}>
                                                                                                
                                                                                                {expandedData[row.indent_no] ? (
                                                                                                    <Table size="small" aria-label="expanded-data">
                                                                                                        <TableHead>
                                                                                                            <TableRow>
                                                                                                                <TableCell></TableCell>

                                                                                                                
                                                                                                                <TableCell sx={{ textAlign: "center" }}>CR NUMBER</TableCell>


                                                                                                                <TableCell sx={{ textAlign: "center" }}>REAM WEIGHT</TableCell>
                                                                                                                <TableCell sx={{ textAlign: "center" }}>STATUS</TableCell>
                                                                                                            </TableRow>
                                                                                                        </TableHead>
                                                                                                        <TableBody>
                                                                                                            {expandedData[row.indent_no].map((item, index) => (
                                                                                                                <TableRow key={index}>
                                                                                                                    <TableCell>{index + 1}</TableCell>

                                                                                                                    
                                                                                                                    <TableCell>{item.cr_number}</TableCell>


                                                                                                                    <TableCell>{item.ream_weight}</TableCell>
                                                                                                                    <TableCell>{item.status}</TableCell>
                                                                                                                </TableRow>
                                                                                                            ))}
                                                                                                        </TableBody>
                                                                                                    </Table>
                                                                                                ) : (
                                                                                                    "Loading..."
                                                                                                )}
                                                                                            </Box> */}

                                                                                                <Box margin={0}>
                                                                                                    {expandedData[row.indent_no] ? (
                                                                                                        <Table size="small" aria-label="expanded-data">
                                                                                                            <TableHead>
                                                                                                                <TableRow>
                                                                                                                    <TableCell></TableCell>
                                                                                                                    <TableCell sx={{ textAlign: "center" }}>CR NUMBER</TableCell>

                                                                                                                    <TableCell sx={{ textAlign: "center" }}>TOTAL WEIGHT</TableCell>
                                                                                                                </TableRow>
                                                                                                            </TableHead>
                                                                                                            <TableBody>
                                                                                                                {(() => {
                                                                                                                    // group data by cr_number + status
                                                                                                                    const grouped = expandedData[row.indent_no].reduce((acc, item) => {
                                                                                                                        const key = `${item.cr_number}_${item.status}`;
                                                                                                                        if (!acc[key]) {
                                                                                                                            acc[key] = {
                                                                                                                                cr_number: item.cr_number,
                                                                                                                                status: item.status,
                                                                                                                                total_weight: 0,
                                                                                                                            };
                                                                                                                        }
                                                                                                                        acc[key].total_weight += Number(item.ream_weight || 0);
                                                                                                                        return acc;
                                                                                                                    }, {});

                                                                                                                    // convert to array for mapping
                                                                                                                    const groupedArray = Object.values(grouped);

                                                                                                                    return groupedArray.map((group, index) => (
                                                                                                                        <TableRow key={index}>
                                                                                                                            <TableCell>{index + 1}</TableCell>
                                                                                                                            <TableCell>{group.cr_number}</TableCell>

                                                                                                                            <TableCell sx={{ textAlign: 'right' }}>
                                                                                                                                {Number(group.total_weight || 0).toFixed(1)}
                                                                                                                            </TableCell>

                                                                                                                            {/* <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>{group.status}</TableCell> */}


                                                                                                                            <TableCell sx={{ textAlign: 'center' }}>
                                                                                                                                <Tooltip title="Child-Reel to Bundle Conversion Status">
                                                                                                                                    <Box
                                                                                                                                        component="span"
                                                                                                                                        sx={{
                                                                                                                                            display: 'inline-block',
                                                                                                                                            px: 1.5,
                                                                                                                                            py: 0.4,
                                                                                                                                            borderRadius: '16px',
                                                                                                                                            bgcolor:
                                                                                                                                                group.status?.toLowerCase() === 'converted'
                                                                                                                                                    ? '#00838f' // gray for converted
                                                                                                                                                    : group.status?.toLowerCase() === 'approved'
                                                                                                                                                        ? '#388e3c' // green for approved
                                                                                                                                                        : group.status?.toLowerCase() === 'wip'
                                                                                                                                                            ? '#0288d1' // blue for work-in-progress
                                                                                                                                                            : '#f57c00', // orange for any other / unknown
                                                                                                                                            color: 'white',
                                                                                                                                            fontWeight: 500,
                                                                                                                                            fontSize: '0.8rem',
                                                                                                                                            textTransform: 'capitalize',
                                                                                                                                            textAlign: 'center',
                                                                                                                                            fontFamily: 'Roboto, sans-serif',
                                                                                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        {group.status}
                                                                                                                                    </Box>
                                                                                                                                </Tooltip>
                                                                                                                            </TableCell>

                                                                                                                        </TableRow>
                                                                                                                    ));
                                                                                                                })()}
                                                                                                            </TableBody>
                                                                                                        </Table>
                                                                                                    ) : (
                                                                                                        "Loading..."
                                                                                                    )}
                                                                                                </Box>

                                                                                            </Collapse>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                )}

                                                                            </React.Fragment>
                                                                        </>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>)}


                                                    </TableContainer>
                                                </CustomTableContainer>
                                            </ResponsiveBox>
                                        </Grid>
                                    </Grid>
                                </>
                            )}

                            {/* view pallet list */}

                            {viewPalletList && (
                                <>
                                    <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>


                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>



                                                <Autocomplete
                                                    fullWidth

                                                    multiple
                                                    size="small"
                                                    options={uniqueCrNumbers}  // Use the uniqueCrNumbers array
                                                    value={cr_number}
                                                    onChange={handleCRNumberChange}
                                                    getOptionLabel={(option) => option}  // Simply use the cr_number value
                                                    isOptionEqualToValue={(option, value) => option === value}  // Match cr_number directly
                                                    renderInput={(params) => (
                                                        <TextField color="secondary" {...params}
                                                            variant="outlined" placeholder="Filter by CR Number" />
                                                    )}
                                                />



                                            </Grid>

                                            <ResponsiveBox customMaxHeight={{
                                                xs: '72vh', // Extra small devices (phones)
                                                sm: '72vh', // Small devices (tablets)
                                                md: '60vh', // Medium devices (small laptops)
                                                lg: '64vh', // Large devices (desktops)
                                                xl: '73vh', // Extra large devices (large desktops)
                                            }}>


                                                <CustomTableContainer colors={colors} >

                                                    <TableContainer >
                                                        <Table size="small">
                                                            <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        <Checkbox
                                                                            sx={{
                                                                                '& .MuiSvgIcon-root': { fontSize: 22 },
                                                                                color: 'secondary'
                                                                            }}
                                                                            indeterminate={someSelected}
                                                                            checked={allSelected}
                                                                            onChange={handleSelectAllClick}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: "center" }}>REAM CODE</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>CR NUMBER</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>SHEET SIZE</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>REAM WEIGHT</TableCell>


                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {filteredReelData.map((row) => (

                                                                    <TableRow key={row.id_ream}
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                            opacity: 1
                                                                        }}

                                                                        onClick={(event) => handleRowClick(event, row.id_ream, row.status)}>
                                                                        <TableCell>
                                                                            <Checkbox
                                                                                size="small"
                                                                                sx={{
                                                                                    '& .MuiSvgIcon-root': { fontSize: 22 }, // Adjust the size of the checkbox icon
                                                                                    color: 'secondary' // Custom color
                                                                                }}
                                                                                checked={isSelected(row.id_ream)}
                                                                                disabled={row.status === 'converted'}
                                                                                onChange={(event) => handleRowCheckboxClick(event, row.id_ream)}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell sx={{ textAlign: "left" }}>{row.ream_code}</TableCell>
                                                                        <TableCell sx={{ textAlign: "left", width: "200px" }}>{row.cr_number}</TableCell>
                                                                        <TableCell sx={{ textAlign: "right", width: "120px" }}>{row.item_code}</TableCell>
                                                                        <TableCell sx={{ textAlign: "right" }}>{row.gsm}</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>{row.sheet_size}</TableCell>
                                                                        <TableCell sx={{ textAlign: "right" }}>{row.ream_weight}</TableCell>


                                                                        <TableCell sx={{ textAlign: 'center' }}>
                                                                            <Tooltip title="Child-Reel to Bundle Conversion Status">
                                                                                <Box
                                                                                    component="span"
                                                                                    sx={{
                                                                                        display: 'inline-block',
                                                                                        px: 1.5,
                                                                                        py: 0.4,
                                                                                        borderRadius: '16px',
                                                                                        bgcolor:
                                                                                            row.status?.toLowerCase() === 'converted'
                                                                                                ? '#00838f' // gray for converted
                                                                                                : row.status?.toLowerCase() === 'approved'
                                                                                                    ? '#388e3c' // green for approved
                                                                                                    : row.status?.toLowerCase() === 'wip'
                                                                                                        ? '#0288d1' // blue for work-in-progress
                                                                                                        : '#f57c00', // orange for any other / unknown
                                                                                        color: 'white',
                                                                                        fontWeight: 500,
                                                                                        fontSize: '0.8rem',
                                                                                        textTransform: 'capitalize',
                                                                                        textAlign: 'center',
                                                                                        fontFamily: 'Roboto, sans-serif',
                                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                                                                                    }}
                                                                                >
                                                                                    {row.status}
                                                                                </Box>
                                                                            </Tooltip>
                                                                        </TableCell>


                                                                    </TableRow>



                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </CustomTableContainer></ResponsiveBox>
                                        </Grid>
                                    </Grid>

                                    <Grid container padding="20px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>

                                    {/* <Grid container padding="20px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                <Button onClick={LoadSelectedLineItemList} variant="contained" color="secondary" size="small">Proceed</Button>
                                            </Box>
                                        </Grid>
                                    </Grid> */}

                                    <Box
                                        sx={{
                                            position: "fixed", // Keep the button fixed at the bottom
                                            bottom: 16, // Distance from the bottom of the viewport
                                            right: 25, // Distance from the right of the viewport
                                            zIndex: 1000, // Ensure it appears above other elements
                                        }}
                                    >

                                        {/* <Button
                                            onClick={LoadSelectedLineItemList}
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                        >
                                            Proceed
                                        </Button> */}



                                        <Button
                                            endIcon={
                                                <DoubleArrowRounded
                                                    className="arrow-icon"
                                                />
                                            }
                                            onClick={LoadSelectedLineItemList}
                                            sx={{
                                                textTransform: "none",
                                                borderRadius: 3,
                                                px: 2,
                                                py: 0.7,
                                                fontWeight: 600,
                                                fontSize: "0.8rem",
                                                letterSpacing: 0.3,
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    backgroundColor: (theme) => theme.palette.secondary.dark,
                                                    transform: "scale(1.03)",
                                                },
                                                "&:hover .arrow-icon": {
                                                    transform: "translateX(5px)",   // move the arrow slightly forward
                                                    transition: "transform 0.3s ease-in-out",
                                                },
                                            }}
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                            disabled={selectedRows.length === 0}
                                        >
                                            Proceed to Next
                                        </Button>

                                    </Box>


                                </>
                            )}


                            {jobID > 0 && (
                                <Grid container padding="1px 10px 10px 25px" sx={{ backgroundColor: colors.primary[400] }} spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                            JOB Number
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={6} xl={6}>
                                        <TextField size="small" value={jobID} />
                                    </Grid>
                                </Grid>
                            )}

                            {viewReamProcess && (
                                <>

                                    <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                        <Grid mt={2} item xs={12} sm={12} md={12} lg={12} xl={12}   >

                                            <Grid container padding="0px 10px 20px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={9} lg={9} xl={9} display="flex-start" justifyContent="center">
                                                    {/* <Box sx={{ borderLeft: '2px solid  #f06292' }}> */}
                                                    {/* #3498db */}
                                                    <Box
                                                        sx={{
                                                            display: 'inline-flex',
                                                            borderBottom: '2px solid #ec407a'  // Underline color
                                                        }}
                                                    >

                                                        <Typography variant="h5" marginLeft="0px" padding="3px" marginTop={0} textAlign="left" >
                                                            Planning Details
                                                        </Typography>

                                                    </Box>

                                                </Grid>


                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={3} display="flex" marginRight="auto" justifyContent="center">
                                                    <Typography variant="subtitle2" marginLeft="auto" marginRight="10px" >Total Reams: {numberofSheets}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container padding="0px 0px 10px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                            </Grid>



                                            <Grid container padding="1px 0px 5px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                                    <Typography variant="h6">{t('prod_sheet_convertion.shift_code')}</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1}>
                                                    <Autocomplete

                                                        fullWidth
                                                        disabled={jobID !== 0} // ✅ disable only when jobId is not 0

                                                        value={winderShiftCode}
                                                        onChange={handleWinderShiftChange}

                                                        size="small"
                                                        style={{ fontSize: '12px' }}
                                                        options={shiftCodes}
                                                        getOptionLabel={(option) => `${option.shiftcode}`}

                                                        renderInput={(params) =>
                                                            <TextField required
                                                                helperText={errorMessage}
                                                                error={errorMessage && errorMessage.length ? true : false}
                                                                {...params} variant="outlined" />}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                                    <Typography variant="h6" marginLeft={1}>{t('prod_sheet_convertion.shift_date_time')}</Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                                    <FormControl fullWidth size="small">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <Stack spacing={1} >
                                                                <DatePicker

                                                                    value={dayjs(shiftDate)}
                                                                    onChange={(date) => setShiftDate(date)}
                                                                    slotProps={{ textField: { size: 'small' }, field: { format: 'DD-MMM-YYYY' } }}
                                                                    fullWidth
                                                                    disabled={jobID !== 0} // ✅ disable only when jobId is not 0

                                                                    renderInput={(props) => (
                                                                        <TextField
                                                                            helperText={shiftdate_errorMessage}
                                                                            error={shiftdate_errorMessage && shiftdate_errorMessage.length ? true : false}
                                                                            {...props} />
                                                                    )}

                                                                />
                                                            </Stack>
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>


                                            </Grid>
                                        </Grid>

                                        <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">


                                            <Grid item xs={12} sm={12} md={1.55} lg={1.55} xl={1.55} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>{t('prod_bundle.reams_in_bundle')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                <TextField
                                                    fullWidth
                                                    disabled={jobID !== 0} // ✅ disable only when jobId is not 0
                                                    //    disabled={jobID > 0} 
                                                    // disabled={disableNumberofSheets}
                                                    size="small"
                                                    required
                                                    type='number'
                                                    value={sheeterNoOfSheets}
                                                    onChange={(e) => setSheeterNoOfSheets(e.target.value)}

                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>{t('prod_bundle.Supervisor')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                                <Autocomplete
                                                    fullWidth
                                                    value={selectedOperator}
                                                    onChange={handleOperatorChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={operator}
                                                    getOptionLabel={(option) => `${option.operator_code}`}
                                                    renderInput={(params) =>
                                                        <TextField required

                                                            {...params} variant="outlined" />}
                                                />
                                            </Grid>

                                        </Grid>

                                        <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={1.55} lg={1.55} xl={1.55} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>{t('prod_bundle.grade')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                <FormControl fullWidth size="small">
                                                    <Autocomplete
                                                        size="small"
                                                        options={["G1", "SL", "Repulp"]}
                                                        value={selectedGrade || ""}
                                                        onChange={(e, value) => {
                                                            setSelectedGrade(value); // Use the second argument to get the selected value
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                sx={{
                                                                    "& .MuiInputBase-input": { padding: "4px" },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginLeft={1} textAlign="left">
                                                    {t('prod_bundle.Remarks')}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={4} xl={4}>

                                                <Box display="flex" alignItems="center">
                                                    <Autocomplete
                                                        size="small"
                                                        fullWidth
                                                        loading={loadingRemarks}
                                                        options={remarkOptions}   // full objects from API
                                                        getOptionLabel={(option) => option?.description || ""}  // 👈 show only description
                                                        // value={data.remarks || ""}  
                                                        value={remarkOptions.find(opt => opt.description === locationRef) || null}
                                                        onChange={(_, newVal) => setLocationRef(newVal.description)}
                                                        renderInput={(params) => (
                                                            <TextField {...params} variant="outlined" />
                                                        )}
                                                    />

                                                    <Tooltip title="Add New Remark">
                                                        <IconButton
                                                            onClick={handleOpenAddRemark}
                                                            size="small"
                                                            sx={{ ml: 1 }}
                                                        >
                                                            <AddCircleOutlineIcon color="secondary" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>

                                                {/* <TextField value={locationRef} onChange={(e) => { setLocationRef(e.target.value) }} fullWidth size="small" type="text" sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'line', } } }}></TextField> */}

                                            </Grid>
                                        </Grid>







                                        <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>
                                        {sheeterNoOfSheets !== 0 && (


                                            <Grid container padding="10px 0px 5px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                                <Grid item xs={11} sm={11} md={10} lg={11.9} xl={11.9} display="flex-start" justifyContent="center">

                                                    <Grid container padding="0px 5px 5px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">


                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="Back to Line item wise achieved reams ">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6">Total Bundles</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{numberofReams || 0}</Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="View available ream list for production">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6">Total L Bundles</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{lossReams || 0}</Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="View available ream list for production">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6">Bundles Weight in Kgs</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{reamWeignt || 0} </Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="View available ream list for production">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6"> L Bundles Weight in Kgs</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{lReamWeignt || 0} </Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />


                                                        {jobID === 0 && (
                                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <Button variant="contained" onClick={InsertBundleDetails} disabled={disableSaveBtn} color="secondary" size="small">Proceed</Button>

                                                                </Box>
                                                            </Grid>
                                                        )}



                                                        <Grid container padding="20px 0px 10px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Box sx={{ borderLeft: '2px solid  #f06292' }}>
                                                                    <Typography sx={{ marginLeft: "10px" }}>
                                                                        Maximum bundle weight: {maxWightBundle} kg, Number of reams per bundle: {numberofSheets}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>


                                                </Grid>

                                            </Grid>
                                        )}
                                        {jobID > 0 && (
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>

                                                    {hasPermission(userPermissions, "Bundle Punching", "Update") && (
                                                        <Tooltip title="Update Bundle Job Details" >
                                                            <Button
                                                                variant="contained"
                                                                color="secondary"
                                                                size="small"
                                                                onClick={handleUpdate}
                                                                sx={{ marginRight: '5px', '& .MuiButton-startIcon': { fontSize: 16 } }}  // controls icon container size
                                                                startIcon={<Edit fontSize="inherit" />}  // inherit font size from container
                                                            >
                                                                Update
                                                            </Button>
                                                        </Tooltip>)}


                                                    {hasPermission(userPermissions, "Bundle Punching", "Delete") && (
                                                        <Tooltip title="Delete Bundle Job Details">
                                                            <Button variant="contained" size="small" onClick={DeleteBundleProductionJobDetails} startIcon={<DeleteForeverOutlinedIcon />} sx={{ backgroundColor: '#e57373' }}>Delete</Button>
                                                        </Tooltip>)}
                                                </Box>


                                            </Grid>
                                        )}
                                    </Grid>

                                    {viewReamQRCode && (
                                        <>
                                            <Grid container padding="0px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid mt={2} mb={0.5} item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                    <Typography variant="h5" fontWeight="bold" marginTop={0} textAlign="left">
                                                        Bundle List
                                                    </Typography>
                                                </Grid>

                                            </Grid>


                                            <Divider sx={{ marginTop: "10px" }} />

                                            <Grid container padding="1px 0px 10px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={11} sm={11} md={6} lg={6} xl={6} display="flex-start" justifyContent="center">
                                                    <CustomTableContainer colors={colors} >
                                                        {bundleListLoding ? (
                                                            <SkeletonTableLoader rows={5} columns={11} />
                                                        ) : (
                                                            <TableContainer >
                                                                <Table size="small">
                                                                    <TableHead sx={{ height: 10 }}>
                                                                        <TableRow>
                                                                            <TableCell>
                                                                                <Checkbox size="small" sx={{

                                                                                    color: 'secondary' // Custom color
                                                                                }}
                                                                                    indeterminate={selectedReamRows.length > 0 && selectedReamRows.length < filteredReamData.length}
                                                                                    checked={selectedReamRows.length === filteredReamData.length}
                                                                                    onChange={handleSelectAllClickPallet}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>BUNDLE CODE</TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>NUMBER OF REAMS</TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>BUNDLE WEIGHT</TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>STATUS</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {reamList.map((row) => {
                                                                            const isChecked = isSelectedReam(row.id_bundle_val);

                                                                            return (
                                                                                <TableRow
                                                                                    key={row.id_bundle_val}
                                                                                    hover
                                                                                    sx={{ cursor: "pointer" }}
                                                                                    onClick={() =>
                                                                                        handleRowCheckboxClickPallet(null, row.id_bundle_val)
                                                                                    }
                                                                                >
                                                                                    <TableCell onClick={(e) => e.stopPropagation()}>
                                                                                        <Checkbox
                                                                                            size="small"
                                                                                            sx={{ color: "secondary" }}
                                                                                            checked={isChecked}
                                                                                            onChange={(event) =>
                                                                                                handleRowCheckboxClickPallet(event, row.id_bundle_val)
                                                                                            }
                                                                                        />
                                                                                    </TableCell>

                                                                                    <TableCell sx={{ textAlign: "left" }}>
                                                                                        {row.bundle_number}
                                                                                    </TableCell>

                                                                                    <TableCell sx={{ textAlign: "right" }}>
                                                                                        {row.no_of_reams}
                                                                                    </TableCell>

                                                                                    <TableCell sx={{ textAlign: "right" }}>
                                                                                        {row.bundle_weight}
                                                                                    </TableCell>

                                                                                    <TableCell sx={{ textAlign: "center" }}>
                                                                                        <Chip
                                                                                            label={row.papyerp_fg_sync_status ? "Converted" : "Approved"}
                                                                                            size="small"
                                                                                            sx={{
                                                                                                color: "#fff",
                                                                                                background: !row.papyerp_fg_sync_status
                                                                                                    ? "linear-gradient(45deg, #388e3c, #2e7d32)"
                                                                                                    : "linear-gradient(45deg, #00838f, #0097a7)",
                                                                                            }}
                                                                                        />
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })}
                                                                    </TableBody>

                                                                    {/* <TableBody>
                                                                        {reamList.map((row) => (
                                                                            <TableRow key={row.id_bundle_val} >
                                                                                <TableCell>
                                                                                    <Checkbox
                                                                                        size="small"
                                                                                        sx={{
                                                                                           
                                                                                            color: 'secondary' 
                                                                                        }}
                                                                                        checked={isSelectedReam(row.id_bundle_val)}
                                                                                       
                                                                                        onChange={(event) => handleRowCheckboxClickPallet(event, row.id_bundle_val)}
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell sx={{ textAlign: "left" }}>{row.bundle_number}</TableCell>
                                                                                <TableCell sx={{ textAlign: "left" }}>{row.no_of_reams}</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>{row.bundle_weight}</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>
                                                                                    <Chip
                                                                                        label={row.papyerp_fg_sync_status ? "Converted" : "Approved"}
                                                                                        variant="filled"
                                                                                        size="small"
                                                                                        sx={{
                                                                                            // fontWeight: "bold",
                                                                                            textTransform: "capitalize",
                                                                                            color: "#fff",
                                                                                            background: !row.papyerp_fg_sync_status
                                                                                                ? "linear-gradient(45deg, #388e3c, #2e7d32)"
                                                                                                : "linear-gradient(45deg, #00838f, #0097a7)",
                                                                                            boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)",
                                                                                            transition: "transform 0.2s ease-in-out",
                                                                                            // "&:hover": {
                                                                                            //   transform: "scale(1.1)",
                                                                                            //   boxShadow: "0 5px 8px rgba(0, 0, 0, 0.3)"
                                                                                            // },
                                                                                        }}
                                                                                    />
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody> */}
                                                                </Table>
                                                            </TableContainer>
                                                        )}
                                                    </CustomTableContainer>
                                                </Grid>
                                            </Grid>

                                            <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                                <Box sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>

                                                    <Toolbar>
                                                        <Button type="submit" onClick={() => viewQRCode()} size="small" variant="contained" color="secondary" startIcon={<QrCode2RoundedIcon />} sx={{ textTransform: 'none' }}>{t('prod_sheet_convertion.btn_view_qr')}</Button>
                                                        <Button type="submit" onClick={() => handleButtonClick('PrintQRAll')} size="small" variant="contained" color="secondary" startIcon={<QrCode2RoundedIcon />} sx={{ marginLeft: '10px', textTransform: 'none' }}>{t('prod_sheet_convertion.btn_print_qr')}</Button>

                                                        {jobID > 0 && (
                                                            <Button type="submit" onClick={() => DeleteSelectedBundleProductionJobDetails()} size="small" variant="contained" startIcon={<DeleteForeverOutlinedIcon />} sx={{ marginLeft: '10px', textTransform: 'none', backgroundColor: '#e57373' }}>Delete</Button>
                                                        )}
                                                    </Toolbar>
                                                </Box>

                                            </Grid>

                                            <Divider sx={{ marginTop: "10px" }} />

                                            <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item mt={1} sm={11} md={11} lg={6} xl={4} >
                                                    <div>
                                                        {selectedReamDetails && selectedReamDetails.length > 0 && (

                                                            <LabelBundleDetails qrCodeValue={''} ProductDetail={selectedReamDetails} company_id={localStorage.getItem('companyid')} packingWeight={packingWeight} />
                                                        )}
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}


                                    <Grid container padding="20px 0px 10px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                                            <Accordion   >

                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon sx={{ fontSize: "0.875rem" }} />}
                                                    sx={{
                                                        minHeight: "28px", // Smaller height for compactness
                                                        padding: "0 8px", // Reduced padding                                                       
                                                        borderRadius: "2px",
                                                        "& .MuiAccordionSummary-content": {
                                                            margin: 0,
                                                            fontSize: "0.75rem", // Smaller font for a compact appearance
                                                            fontWeight: "bold",
                                                        },
                                                        "&.Mui-expanded": {
                                                            minHeight: "24px", // Keeps the header thin even when expanded
                                                        },
                                                    }}
                                                >
                                                    <Box display="flex" alignItems="center">
                                                        {/* Add the icon here */}
                                                        <InfoIcon sx={{ marginRight: '4px', fontSize: 16, color: colors.blueAccent[500] }} />
                                                        <Typography variant="subtitle2">View Customer Details</Typography>
                                                    </Box>


                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box
                                                        sx={{
                                                            // backgroundColor: colors.primary[700],
                                                            // padding: "10px",
                                                            borderRadius: "10px",
                                                            // marginTop: "10px",
                                                            maxHeight: {
                                                                xs: '72vh', // Extra small devices (phones)
                                                                sm: '72vh', // Small devices (tablets)
                                                                md: '74vh', // Medium devices (small laptops)
                                                                lg: '30vh', // Large devices (desktops)
                                                                xl: '30vh', // Extra large devices (large desktops)
                                                            },
                                                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                                            '&::-webkit-scrollbar': {
                                                                width: '8px',
                                                            },
                                                            '&::-webkit-scrollbar-track': {
                                                                background: colors.primary[400],
                                                                borderRadius: '10px',
                                                            },
                                                            '&::-webkit-scrollbar-thumb': {
                                                                background: colors.blueAccent[600],
                                                                borderRadius: '10px',
                                                                '&:hover': {
                                                                    background: colors.blueAccent[800],
                                                                },
                                                            },
                                                            '&::-webkit-scrollbar-corner': {
                                                                background: colors.primary[700],
                                                            }
                                                        }}>
                                                        <>
                                                            <Box sx={{ padding: "5px", borderRadius: "1px" }}>
                                                                {/* backgroundColor: colors.primary[400], */}
                                                                <CustomTableContainer colors={colors} >

                                                                    <TableContainer >
                                                                        <Table size="small">
                                                                            <TableHead sx={{ height: 0 }}>
                                                                                <TableRow>

                                                                                    <TableCell sx={{ textAlign: "center" }}>CO DATE</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>CO NUMBER</TableCell>
                                                                                    {/* <TableCell sx={{ textAlign: "center" }}>CUSTOMER NAME</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>SUPPLIER NAME</TableCell> */}
                                                                                    <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>WIDTH</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>LENGTH</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>PRODUCED REAMS</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>ACH.QTY</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>PRODUCED QTY</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>TOTAL BUNDLE</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>REAM WEIGHT</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>NO.OF.SHEETS IN REAM</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>LINE NUMBER</TableCell>
                                                                                    <TableCell>
                                                                                        <IconButton >
                                                                                            {/* onClick={handleOpen} */}
                                                                                            <Searchicon style={{ fontSize: "16px" }} />
                                                                                        </IconButton>
                                                                                        <Modal
                                                                                            // open={open}
                                                                                            // onClose={handleClose}
                                                                                            aria-labelledby="modal-modal-title"
                                                                                            aria-describedby="modal-modal-description"
                                                                                        >
                                                                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                                                <TextField
                                                                                                    label="Parent Roll Number"
                                                                                                    name="name"
                                                                                                    // value={filters.pr_number}
                                                                                                    // onChange={handleFilterChange}
                                                                                                    variant="outlined"
                                                                                                    fullWidth
                                                                                                    margin="normal"
                                                                                                />
                                                                                                <TextField
                                                                                                    label="MA Number"
                                                                                                    name="companyName"
                                                                                                    // value={filters.release_no}
                                                                                                    // onChange={handleFilterChange}
                                                                                                    variant="outlined"
                                                                                                    fullWidth
                                                                                                    margin="normal"
                                                                                                />

                                                                                                <TextField
                                                                                                    label="Status"
                                                                                                    name="status"
                                                                                                    // value={filters.status}
                                                                                                    // onChange={handleFilterChange}
                                                                                                    variant="outlined"
                                                                                                    fullWidth
                                                                                                    margin="normal"
                                                                                                />


                                                                                                <Button variant="contained" style={{ marginTop: 10 }}>
                                                                                                    {/* onClick={handleClose}  */}
                                                                                                    Apply Filter
                                                                                                </Button>
                                                                                            </Box>
                                                                                        </Modal>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {selectedLineItemDetail.map((row) => (
                                                                                    <TableRow key={row.id}>

                                                                                        <TableCell sx={{ textAlign: "center" }}>{row.indent_date}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "left", fontWeight: "bold" }}>
                                                                                            <span
                                                                                                style={{ color: '#039be5', textDecoration: 'underline', cursor: 'pointer' }}
                                                                                                onClick={() => handleCallEdit(row.indent_no, row.line_no)}
                                                                                            >
                                                                                                {row.indent_no}
                                                                                            </span>
                                                                                        </TableCell>
                                                                                        {/* <TableCell sx={{ textAlign: "left" }}>{row.customer_name}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "left" }}>{row.supplier_name}</TableCell> */}
                                                                                        <TableCell sx={{ textAlign: "left" }}>{row.item_code}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.d_width}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.d_length}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.reel_count}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.total_qty}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.plannedqty}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.bundle_count}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.ream_weight}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.no_of_sheets}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "center" }}>{row.line_no}</TableCell>
                                                                                    </TableRow>
                                                                                ))}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </CustomTableContainer>
                                                            </Box>
                                                        </>
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>

                                    <Grid container padding="5px 0px 0px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"  >
                                        <Grid item xs={11} sm={11} md={11} lg={12} xl={12} display="flex-start" justifyContent="center" marginBottom="auto">
                                            <Accordion   >
                                                {/*sx={{ backgroundColor: colors.primary[500] }} */}
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon sx={{ fontSize: "0.875rem" }} />}
                                                    sx={{
                                                        minHeight: "28px", // Smaller height for compactness
                                                        padding: "0 8px", // Reduced padding
                                                        // backgroundColor: colors.primary[400],
                                                        borderRadius: "2px",
                                                        "& .MuiAccordionSummary-content": {
                                                            margin: 0,
                                                            fontSize: "0.75rem", // Smaller font for a compact appearance
                                                            fontWeight: "bold",
                                                        },
                                                        "&.Mui-expanded": {
                                                            minHeight: "24px", // Keeps the header thin even when expanded
                                                        },
                                                    }}
                                                >
                                                    <Box display="flex" alignItems="center">
                                                        {/* Add the icon here */}
                                                        <InfoIcon sx={{ marginRight: '4px', fontSize: 16, color: colors.blueAccent[500] }} />
                                                        <Typography variant="subtitle2">View Selected Reams</Typography>
                                                    </Box>


                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box
                                                        sx={{
                                                            // backgroundColor: colors.primary[700],
                                                            // padding: "10px",
                                                            borderRadius: "10px",
                                                            // marginTop: "10px",
                                                            maxHeight: {
                                                                xs: '72vh', // Extra small devices (phones)
                                                                sm: '72vh', // Small devices (tablets)
                                                                md: '74vh', // Medium devices (small laptops)
                                                                lg: '30vh', // Large devices (desktops)
                                                                xl: '30vh', // Extra large devices (large desktops)
                                                            },
                                                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                                            '&::-webkit-scrollbar': {
                                                                width: '8px',
                                                            },
                                                            '&::-webkit-scrollbar-track': {
                                                                background: colors.primary[400],
                                                                borderRadius: '10px',
                                                            },
                                                            '&::-webkit-scrollbar-thumb': {
                                                                background: colors.blueAccent[600],
                                                                borderRadius: '10px',
                                                                '&:hover': {
                                                                    background: colors.blueAccent[800],
                                                                },
                                                            },
                                                            '&::-webkit-scrollbar-corner': {
                                                                background: colors.primary[700],
                                                            }
                                                        }}>
                                                        <>
                                                            <Box
                                                                display="flex"
                                                                flexDirection="column"
                                                                alignItems="center"
                                                                padding={0.5}
                                                                sx={{
                                                                    "& .MuiTable-root": {
                                                                        border: "none",
                                                                        size: "small",
                                                                    },
                                                                    "& .MuiTableCell-root": {
                                                                        borderBottom: "none",
                                                                        border: "1px solid",
                                                                        borderColor: `${colors.primary[100]} !important`,
                                                                    },
                                                                    "& .name-column--cell": {
                                                                        color: colors.greenAccent[300],
                                                                    },
                                                                    "& .MuiTableHead-root": {
                                                                        borderBottom: "none",
                                                                    },
                                                                    "& .MuiTableBody-root": {
                                                                        overflowY: "auto",
                                                                    },
                                                                    "& .MuiCheckbox-root": {
                                                                        color: `${colors.blueAccent[200]} !important`,
                                                                        size: "small",
                                                                    },
                                                                    "& .MuiTableFooter-root": {
                                                                        borderTop: "none",
                                                                        backgroundColor: colors.blueAccent[700],
                                                                        height: "10px",
                                                                    },
                                                                    "& .MuiButton-text": {
                                                                        color: `${colors.grey[100]} !important`,
                                                                    },
                                                                }}
                                                            >
                                                                <TableContainer>
                                                                    <Table size="small">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell sx={{ textAlign: "center" }}>REAM NUMBER</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>SIZE</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>WEIGHT</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>NO OF SHEETS</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>STATUS</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {selectedReelList.map((row) => (
                                                                                <TableRow key={row.id_reel}>

                                                                                    <TableCell sx={{ textAlign: "center" }}>
                                                                                        {/* {row.ream_code} */}
                                                                                        <span
                                                                                            style={{ color: '#039be5', cursor: 'pointer' }}

                                                                                        >
                                                                                            {row.ream_code}
                                                                                        </span>
                                                                                    </TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.item_code}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.sheet_size}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.ream_weight}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.number_of_sheets}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.status}</TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </Box>
                                                        </>
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>



                                </>
                            )}


                        </>

                    </Box>

                    <Box
                        sx={{
                            padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '74vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>

                        {viewReamLabeling && (
                            <div>

                                {showCard && (
                                    <Grid container padding="15px 0px 10px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                        <Grid item xs={10.1} sm={10.6} md={11.9} lg={11.92} xl={11.95} display="flex-start" justifyContent="center">
                                            <Card sx={{ backgroundColor: colors.primary[500], borderRadius: "5px" }}>
                                                <CardContent>
                                                    <Box display="flex">
                                                        <Box>
                                                            <Typography sx={{ marginBottom: "5px" }}>Customer Details</Typography>
                                                        </Box>

                                                        <IconButton onClick={handleHide} sx={{ marginLeft: "auto" }} >
                                                            <CloseIcon style={{ color: "#ff5252", fontSize: "16px", fontWeight: "bold" }} />
                                                        </IconButton>

                                                    </Box>

                                                    <Box
                                                        gridColumn="span 9"
                                                        gridRow="span 2"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        // padding={1}
                                                        sx={{
                                                            "& .MuiTable-root": {
                                                                border: "none",
                                                                size: "small",
                                                            },
                                                            "& .MuiTableCell-root": {
                                                                borderBottom: "none",
                                                                border: "1px solid",
                                                                borderColor: `${colors.blueAccent[700]} !important`,
                                                                padding: "2px",  // Further reduced padding
                                                            },
                                                            "& .MuiTableHead-root": {
                                                                borderBottom: "none",
                                                            },
                                                            "& .MuiTableBody-root": {
                                                                overflowY: "auto",
                                                            },
                                                            "& .MuiCheckbox-root": {
                                                                color: `${colors.blueAccent[200]} !important`,
                                                                size: "small",
                                                            },
                                                            "& .MuiTableFooter-root": {
                                                                borderTop: "none",
                                                                backgroundColor: colors.blueAccent[700],
                                                                height: "10px",
                                                            },
                                                            "& .MuiButton-text": {
                                                                color: `${colors.grey[100]} !important`,
                                                            },
                                                        }}
                                                    >
                                                        <Table >
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Customer Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Supplier Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Indent Number</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Indent Date</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Line Number</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Master Reel</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Width</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Quality</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>GSM</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Diameter</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Inner Core</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Reel Length</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Reel Weight</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Number of Sheets</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Produced MO Number</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {childRollDetails?.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.customer_name || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.supplier_name || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.indent_no || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{formatDate(row.indent_date) || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.line_no || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.master_reel || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.d_width || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.quality || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.gsm || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.diameter || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.inner_core || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.reel_length || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.achieved_qty || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.no_of_sheets || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.mo_number || "N/A"}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </Box>
                                                </CardContent>
                                            </Card>

                                        </Grid>
                                    </Grid>
                                )}
                            </div>
                        )}
                    </Box>
                </>

            )
            }
            {openAddRemark && (
                <AddRemarks open={openAddRemark} onClose={handleCloseAddRemark} moduleName={"Bundle Punching"} parentModuleName={"Production"} userPermissions={userPermissions} />
            )}



        </Box >
    )
}
export default BundleLabel;